import { matchWords } from "../helpers/matcher";
export const interactions = {
  // 1
  "Schritt1 Start": {
    en: `Hāi, nín hǎo. [b]Welcome [/b]to the world of secret societies.`,
    de: `Hāi, nín hǎo. Willkommen in der Welt der Geheimbünde.`,
    interaction: (message) => {
      if (
        matchWords(message, [
          "HELLO HUANG", "HALLO HUANG", "Hallo Huang", "Hello Huang", "lösung", "Solución", 'Solution', "loesung", "huang", "hallohuang"
        ])
      )
        return `ST_2_1_Hong`;

      if (
        matchWords(message, [
          "Hilfe",
          "Hinweis",
          "ayuda",
          "aide",
          "help",
        ])
      )
        return `H_Schritt_1`;

      if (
        matchWords(message, [
          "HELLO CHRISTIAN", "HALLO CHRISTIAN", "Hallo Christian", "Hello Christian", "Christian", "HalloChristian", "hellochristian", "halochristian"
        ])
      )
        return `*SD_4_1_Level`;

      return "Klammer1";
    },
  },
  // 2
  "ST_2_1_Hong": {
    en: `My friend, I am glad that you accepted my invitation. To be accepted into our club, you must show that you want to be one of us. Complete four orders for us online, I have deposited them for you on the intranet of our association. The address is understandably encrypted: https://tinyurl.com/xxxxintra, where xxxx stands for 3-8-20-1. 
    ::next-5::
    [img]https://www.paragamix.com/images/Singapur/SchriftzeichenE.gif[/img]
    [url=https://www.paragamix.com/images/Singapur/SchriftzeichenE.gif]enlarge[/url]
    ::next-1::
    Enter the word you are looking for in the chat. I wish you good luck.
    [button=https://soundcloud.com/baba-beach-club/moonface-09-10mp3]Background music[/button]
    `,
    de: `Mein Freund, es freut mich, dass du meiner Einladung gefolgt bist. Um in unseren Verein aufgenommen zu werden, musst du zeigen, dass du einer von uns sein willst. Erledige online vier Aufträge für uns, ich habe sie im Intranet unseres Vereins für dich hinterlegt. Die Adresse ist verständlicherweise verschlüsselt: https://tinyurl.com/intraxxxx, wobei xxxx für 3-8-20-1 steht. 
    ::next-7::
    [img]https://www.paragamix.com/images/Singapur/SchriftzeichenE.gif[/img]
    [url=https://www.paragamix.com/images/Singapur/SchriftzeichenE.gif]vergrößern[/url]
    ::next-2::
    Gib das gesuchte Wort im Chat ein. Ich wünsche dir viel Erfolg.
    [button=https://soundcloud.com/baba-beach-club/moonface-09-10mp3]Hintergrundmusik[/button]
    `,
    interaction: (message) => {
      if (
        matchWords(message, [
          "lösung",
          "Solución",
          "Solution",
          "loesung",
          "Hong",
          "https://tinyurl.com/hongintra",
          "http://tinyurl.com/hongintra",
          "hongintra"
        ])
      )
        return `ST_3_1_Intranet`;

      if (
        matchWords(message, [
          "Hilfe",
          "ayuda",
          "aide",
          "help",
        ])
      )
        return `HT_2_1_Hong`;

      return "KT_2_1_Hong";
    },
  },
  // 3
  "ST_3_1_Intranet": {
    en: `Very good, you have successfully mastered this task. I am a member of the Hong Brotherhood. On the day of our founding, there was a bright red glow in the sky that inspired us to change our last name to Hong (洪), which sounds like the Mandarin character for "red" (红). This completes the URL and gives you access to our intranet.
    ::next-7::
    You have decrypted the URL to our intranet.
    Take your first job.
    [button=https://tinyurl.com/intraHong]Hong Intranet[/button]
    [button=interaction-ST_4_1_409]first job[/button]
    ::next-3::
    [img]https://www.paragamix.com/images/Singapur/st-3-1-intranet.png[/img]
    `,
    de: `Sehr gut, diese Aufgabe hast du erfolgreich gemeistert. Ich bin Mitglied der Hong Bruderschaft. Am Tag der Gründung gab es ein leuchtend rotes Leuchten am Himmel, das uns dazu inspirierte, unseren Nachnamen in Hong (洪) zu ändern, das wie das Mandarin-Zeichen für "rot" (红) klingt. 
    Damit ist die URL vollständig und du hast Zugriff auf unser Intranet.
    ::next-7::
    Du hast die URL zu unserem Intranet entschlüsselt.
    Übernimm deinen ersten Auftrag.
    [button=https://tinyurl.com/intraHong]Hong Intranet[/button]
    [button=interaction-ST_4_1_409]erster Auftrag[/button]
    ::next-3::
    [img]https://www.paragamix.com/images/Singapur/st-3-1-intranet.png[/img]
    `,
    disableInput: true,
    interaction: (message) => {
      if (
        matchWords(message, [
          "Hilfe",
          "Hinweis",
          "ayuda",
          "aide",
          "help",
        ])
      )
        return `Hilfe3`;

      return "Klammer3";
    },
  },
  // 4
  "ST_4_1_409": {
    en: `[url=https://parablog.wixsite.com/hongenglish]Job #1[/url]

    [b]Read through your first assignment on the Hong Intranet[/b] and follow my instructions exactly. Later you can also call the orders directly via #1, #2, #3 or #4.
    ::next-2::
    [b]When things get stuck: [/b]With RESTART you start anew. After that, just enter the number of the job (e.g. #1 for the first job) and you start where you left off. Please don't scroll back too far in the chat, it will cause a crash.
    ::next-1::
    [b]Multiple players:[/b] Split the jobs and exchange via WhatsApp, etc. Jump directly to the order with entry of the number (e.g. #1 for the 1st order). You can play the same mission in a team parallel as detective or perpetrator or play both perspectives one after the other with the same code.
    ::next-1::
    [url=https://goo.gl/maps/MzTniP4xxaxUL83L6]Click here,[/url] find out what room he's staying in, then call me from the hotel. I'll take care of the rest.    
    `,
    de: `[b]Auftrag 1:[/b]
    [url=https://parablog.wixsite.com/hong]Lies deinen ersten Auftrag im Hong Intranet durch[/url] und folge genau meinen Anweisungen. Später kannst du die Aufträge über #1, #2, #3 oder #4 auch direkt aufrufen.
    ::next-5::
    [b]Wenn es mal klemmt: [/b]Mit NEUSTART startest du neu. Gib danach einfach die Nummer des Auftrags ein (z.B. #1 für den ersten Auftrag) und du startest da wo du aufgehört hast. Bitte im Chat nicht zu weit zurück scrollen, das führt zu einem Absturz.
    ::next-2::
    [b]Mehrere Spieler:[/b] Teilt die Aufträge auf und tauscht euch über WhatsApp etc. aus. Springt direkt in den Auftrag mit Eingabe der Nummer (z.B. #1 für den 1. Auftrag). Ihr könnt im Team die gleiche Mission parallel als Täter oder gegen Erwerb eines Mission Codes auch als Detektiv spielen oder mit dem gleichen Code beide Perspektiven nacheinander spielen.
    ::next-3::
    [url=https://goo.gl/maps/MzTniP4xxaxUL83L6]Klicke hier, [/url] finde heraus, in welchem Zimmer er übernachtet und rufe mich dann aus dem Hotel an. Ich kümmere mich um den Rest.
    `,
    interaction: (message) => {
      if (
        matchWords(message, [
          "lösung",
          "Solución",
          "Solution",
          "409",
        ])
      )
        return `ST_40_1_Safe`;

      if (
        matchWords(message, [
          "Hilfe",
          "Hinweis",
          "ayuda",
          "aide",
          "help",
        ])
      )
        return `HT_4_1_409`;

      return "KT_4_1_409";
    },
  },
  // 5
  "ST_40_1_Safe": {
    en: `The jewelry is stored in the safe. I need the right combination to adjust the wheel. Our brother has already figured out the first numbers and written them down for you on the wall right next to the entrance door.
    ::next-4::
    However, the last two digits are still missing. 
    [button=https://www.paragamix.com/dsinga/fullT/app-files/index.html]Room 409[/button]`,
    de: `Der Schmuck ist im Safe aufbewahrt. Ich brauche die richtige Kombination zur Einstellung des Rads. Die ersten Zahlen hat unser Bruder bereits herausgefunden und für dich direkt neben der Eingangstür auf der Wand notiert. 
    ::next-4::
    Die letzten beiden Ziffern fehlen aber noch. 
    [button=https://www.paragamix.com/dsinga/fullT/app-files/index.html]Zimmer 409[/button]
    `,
    interaction: (message) => {
      if (
        matchWords(message, [
          "lösung",
          "Solución",
          "Solution",
          "loesung",
          "123837465",
          "65",
          "6 5",
          "6,5",
        ])
      )
        return `ST_4a_1_Telefon`;

      if (
        matchWords(message, [
          "Hilfe",
          "ayuda",
          "aide",
          "help",
        ])
      )
        return `HT_40_1_Safe`;

      return "KT_40_1_Safe";
    },
  },
  // 6
  "ST_4a_1_Telefon": {
    en: `Well done, I will try that out right away. Call me from the hotel room and let me know if the coast is clear. My phone number is of course encrypted.
    Our brother wrote them down on a notepad on the phone.`,
    de: `Gut gemacht, das werde ich gleich ausprobieren. Rufe mich aus dem Hotelzimmer an und teile mir mit ob die Luft rein ist. Meine Telefonnummer ist selbstverständlich verschlüsselt. 
    Unser Bruder hat sie auf einem Notizzettel am Telefon notiert. `,
    interaction: (message) => {
      if (
        matchWords(message, [
          "lösung",
          "Solución",
          "Solution",
          "loesung",
          "25784",
        ])
      )
        return `ST_4b_1_Zertifikat1`;

      if (
        matchWords(message, [
          "Hilfe",
          "ayuda",
          "Hinweis",
          "aide",
          "help",
        ])
      )
        return `HT_4a_1_Telefon`;

      return "KT_4a_1_Telefon";
    },
  },
  // 7
  "ST_4b_1_Zertifikat1": {
    en: `[video]https://www.youtube.com/embed/YgqhEyxbvxU[/video]
    [url=https://www.youtube.com/embed/YgqhEyxbvxU]enlarge[/url]
    ::next-7::
    The coast is clear, I'll do the rest. For your good work, I give you part of your certificate.
    ::next-4::
    [img]https://www.paragamix.com/images/Singapur/st-4b-1-zertifikat1.png[/img]
    ::next-4::
    You are making good progress. I am pleased with you. The next order is very close to my heart.
    [button=interaction-ST_5_2_Galerie]next job[/button]`,
    de: `[video]https://www.youtube.com/embed/YgqhEyxbvxU[/video]
    [url=https://www.youtube.com/embed/YgqhEyxbvxU]vergrößern[/url]
    ::next-7::
    Die Luft ist rein, den Rest erledige ich. Für deine gute Arbeit übergebe ich dir einen Teil deines Zertifikats.
    ::next-4::
    [img]https://www.paragamix.com/images/Singapur/st-4b-1-zertifikat1.png[/img]
    ::next-4::
    Du machst gute Fortschritte. Ich bin zufrieden mir dir. Der nächste Auftrag liegt mir sehr am Herzen.
    [button=interaction-ST_5_2_Galerie]nächster Auftrag[/button]
    `,
    disableInput: true,
    interaction: (message) => {
    },
  },
  // 8
  "ST_5_2_Galerie": {
    en: `[url=https://parablog.wixsite.com/hongenglish]Job #2[/url]
    A good friend is an admirer of Balian art. I would like to grant him a wish. There is an artist at the National Gallery whose work is about Bali.
    ::next-1::
    Give me her name and I'll take care of the rest.
    [button=https://www.paragamix.com/dsinga/singapurartT/app-files/index.html]Museum[/button]
    `,
    de: `[url=https://parablog.wixsite.com/hong]Auftrag #2[/url]
    Der guter Freund ist ein Bewunderer von Balischer Kunst. Ich möchte ihm einen Wunsch erfüllen. Es gibt in der National Gallery eine Künstlerin, die sich in ihren Werken mit Bali beschäftigt. 
    ::next-1::
    Nenne mir ihren Namen, ich kümmere mich um den Rest.
    [button=https://www.paragamix.com/dsinga/singapurartT/app-files/index.html]Museum[/button]
    `,
    interaction: (message) => {
      if (
        matchWords(message, [
          "lösung",
          "Solución",
          "Solution",
          "loesung",
          "LiuKang",
          "Liu",
          "Kang"
        ])
      )
        return `ST_5a_2_Bildfehler`;

      if (
        matchWords(message, [
          "Hilfe",
          "ayuda",
          "Hinweis",
          "aide",
          "help",
        ])
      )
        return `HT_5_2_Galerie`;

      return "KT_5_2_Galerie";
    },
  },
  // 9
  "ST_5a_2_Bildfehler": {
    en: `Thank you for your advice. I replaced the picture in the museum with a copy. It will not be noticed, although our brother was inaccurate in copying. I have already found 2 deviations. How many mistakes do you find?
    ::next-4::
    [img]https://www.paragamix.com/images/Singapur/px_singapur_suchbild_1.jpg[/img]
    [url=https://www.paragamix.com/images/Singapur/px_singapur_suchbild_1.jpg]enlarge[/url]
    `,
    de: `Danke für deinen Hinweis. Ich habe das Bild im Museum ausgetauscht durch eine Kopie. Es wird nicht auffallen, obwohl unser Bruder beim Kopieren ungenau gearbeitet hat. Ich habe schon 2 Abweichungen gefunden. Wie viele Fehler findest du?
    ::next-4::
    [img]https://www.paragamix.com/images/Singapur/px_singapur_suchbild_1.jpg[/img]
    [url=https://www.paragamix.com/images/Singapur/px_singapur_suchbild_1.jpg]vergrößern[/url]`,
    interaction: (message) => {
      if (
        matchWords(message, [
          "lösung",
          "Solución",
          "Solution",
          "loesung",
          "5",
        ])
      )
        return `ST_6_3_Restaurant`;

      if (
        matchWords(message, [
          "Hilfe",
          "ayuda",
          "Hinweis",
          "aide",
          "help",
        ])
      )
        return `HT_5a_2_Bildfehler`;

      return 'KT_5a_2_Bildfehler'
    },
  },

  // 10
  "ST_6_3_Restaurant": {
    en: `[url=https://parablog.wixsite.com/hong]Job #3[/url]
    The Temple Street restaurant across from Galaxy Tattoo is no longer making payments to our fraternity, although it is doing brilliant business. I will eat my favorite dish there one last time, but just can't come up with the name of the dish.
    ::next-3::
    [iframe]<iframe src="https://www.google.com/maps/embed?pb=!4v1750065738469!6m8!1m7!1sTaRXiSU86h1S82ZAAL9qRA!2m2!1d1.282837128717677!2d103.8442257224807!3f301.75!4f-5.599999999999994!5f0.7820865974627469" width="350" height="400" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>[/iframe]
    ::next-1::
    Figure it out, and I'll take care of the rest.
    [button=https://maps.app.goo.gl/AANzhEJaLYreE9vs7]Restaurant[/button]
    `,
    de: `[url=https://parablog.wixsite.com/hong]Auftrag #3[/url]
    Das Restaurant in der Temple Street gegenüber Galaxy Tattoo leistet keine Zahlungen mehr an unsere Bruderschaft, obwohl es glänzende Geschäfte macht. Ich werde dort ein letztes mal mein Lieblingsgericht essen, komme aber einfach nicht auf den Namen des Gerichts.
    ::next-3::
    [iframe]<iframe src="https://www.google.com/maps/embed?pb=!4v1750065738469!6m8!1m7!1sTaRXiSU86h1S82ZAAL9qRA!2m2!1d1.282837128717677!2d103.8442257224807!3f301.75!4f-5.599999999999994!5f0.7820865974627469" width="350" height="400" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>[/iframe]
    ::next-1::
    Finde es heraus, dann kümmere ich mich um den Rest.
    [button=https://maps.app.goo.gl/AANzhEJaLYreE9vs7]Restaurant[/button]
    `,
    interaction: (message) => {
      if (
        matchWords(message, [
          "lösung",
          "Solución",
          "Solution",
          "loesung",
          "Karotte",
          "Karotten",
          "Karattenkuchen",
          "kuchen",
          'zanahoria',
          "Cake",
          "carotte",
          "CarrotCake",
          "carrot"
        ])
      )
        return `ST_6a_3_Quittung`;

      if (
        matchWords(message, [
          "Hilfe",
          "ayuda",
          "Hinweis",
          "aide",
          "help",
        ])
      )
        return `HT_6_3_Restaurant`;

      return 'KT_6_3_Restaurant'
    },
  },
  // 11
  "ST_6_3_YumCha": {
    en: `Yum Cha is the name of the restaurant. However, I am looking for my favorite dish that I like to eat there.`,
    de: `Yum Cha ist der Name des Restaurants. Ich suche aber mein Lieblingsgericht, das ich dort gerne esse.`,
    interaction: (message) => {
      if (
        matchWords(message, [
          "lösung",
          "Solución",
          "Solution",
          "loesung",
          'Karotte',
          'Karotten',
          'Karattenkuchen',
          'kuchen',
          'zanahoria',
          'Cake',
          'carotte',
          'CarrotCake',
          'carrot'
        ])
      )
        return `ST_6a_3_Quittung`;

      if (
        matchWords(message, [
          "Hilfe",
          "ayuda",
          "Hinweis",
          "aide",
          "help",
        ])
      )
        return `HT_6_3_Restaurant`;

      return 'KT_6_3_Restaurant'
    },
  },
  // 12
  "ST_6a_3_Quittung": {
    en: `Thanks for the tip. I had an excellent meal. Too bad the explosion completely destroyed the restaurant. I will miss it. From the menu you can see how we Hong brothers eat traditionally.
    ::next-3::
    [img]https://www.paragamix.com/images/Singapur/singapur_rezept.gif[/img]
    [url=https://www.paragamix.com/images/Singapur/singapur_rezept.gif]enlarge[/url]`,
    de: `Danke für den Tipp. Ich habe hervorragend gepeist. Schade, dass die Explosion das Restaurant komplett zerstört hat. Ich werde es vermissen. Der Speisenkarte kannst Du entnehmen, wie wir Hong Brüder uns traditionell ernähren.
    ::next-3::
    [img]https://www.paragamix.com/images/Singapur/singapur_rezept.gif[/img]
    [url=https://www.paragamix.com/images/Singapur/singapur_rezept.gif]vergrößern[/url]`,
    interaction: (message) => {
      if (
        matchWords(message, [
          'lösung', 'loesung', 'vegetarisch', 'solution', 'vegetarian', 'végétarien', 'vegetariana', 'vegetariano'
        ])
      )
        return `ST_6b_3_Zusatz`;

      if (
        matchWords(message, [
          "Hilfe",
          "ayuda",
          "aide",
          "help",
        ])
      )
        return `HT_6a_3_Quittung`;

      return 'KT_6a_3_Quittung'
    },
  },
  // 13
  "ST_6b_3_Zusatz": {
    en: `For your good work, I present you with another part of your certificate.
    ::next-1::
    [img]https://www.paragamix.com/images/Singapur/st-6b-3-zusatz.png[/img]
    Are you ready for your next assignment?
    [button=interaction-ST_7_4_Markt]next job[/button]`,
    de: `Für deine gute Arbeit überreiche ich dir einen weiteren Teil deines Zertifikats.
    ::next-1::
    [img]https://www.paragamix.com/images/Singapur/st-6b-3-zusatz.png[/img]
    Bist du bereit für deinen nächsten Auftrag?
    [button=interaction-ST_7_4_Markt]nächster Auftrag[/button]
`,
    disableInput: true,
    interaction: (message) => {
      if (
        matchWords(message, [
          'lösung', 'loesung', 'vegetarisch', 'solution', 'vegetarian', 'végétarien', 'vegetariana', 'vegetariano'
        ])
      )
        return `ST_6b_3_Zusatz`;

      if (
        matchWords(message, [
          "Hilfe",
          "ayuda",
          "aide",
          "help",
        ])
      )
        return `HT_6a_3_Quittung`;

      return 'KT_6a_3_Quittung'
    },
  },
  // 14
  "ST_7_4_Markt": {
    en: `[b]Job #4[/b]
    One of our brothers violated his oath and betrayed our business to the Kryziu Kalne clan. When a brother enters another brother's house, he must be served tea and rice. If a brother does not do this, he may die losing his blood on the road.
    ::next-3::
    [iframe]<iframe src="https://www.google.com/maps/d/embed?mid=1WfHn85X9cVJQ2OmnO5G7It9fFLffoWli" width="500" height="500"></iframe>[/iframe]
    ::next-1::
    Find out the name of his store somewhere in the southeast part of the Chinese market and I'll take care of the rest.
    [button=https://www.paragamix.com/pxsingapur/china/app-files/index.html]China market[/button]`,
    de: `[b]Auftrag #4[/b]
    Einer unserer Brüder hat gegen seinen Eid verstossen und unsere Geschäfte an den Kryziu Kalne Clan verraten. Wenn ein Bruder das Haus eines anderen Bruders betritt, müssen ihm Tee und Reis serviert werden. Wenn ein Bruder dies nicht tut, kann er sterben, indem er sein Blut auf der Straße verliert.
    ::next-3::
    [iframe]<iframe src="https://www.google.com/maps/d/embed?mid=1WfHn85X9cVJQ2OmnO5G7It9fFLffoWli" width="500" height="500"></iframe>[/iframe]
    ::next-1::
    Finde den Namen seines Geschäfts irgendwo im südöstlichen Teil des Chinesenmarkts heraus und ich kümmere mich um den Rest.
    [button=https://www.paragamix.com/pxsingapur/china/app-files/index.html]Chinamarkt[/button]`,
    interaction: (message) => {
      if (
        matchWords(message, [
          'lösung', 'Solución', 'Solution', 'loesung', 'Poh', 'Chang', 'Sheng'
        ])
      )
        return `ST_7a_4_Diktator`;

      if (
        matchWords(message, [
          "Hilfe",
          'Hinweis',
          "ayuda",
          "aide",
          "help",
        ])
      )
        return `HT_7_4_Markt`;

      return 'KT_7_4_Markt'
    },
  },
  // 15
  "ST_7a_4_Diktator": {
    en: `I took care of it. We exchanged the traitor for one of the dictators as a deterrent and put it on display in the museum. The dictator is now swimming in Marina Bay.
    ::next-2::
    [img]https://www.paragamix.com/images/Singapur/SAM_newspaperE.jpg[/img]
    [url=https://www.paragamix.com/images/Singapur/SAM_newspaperE.jpg]enlarge[/url]
    ::next-5::
    For this order you will receive another part of your certificate. We need bright minds for our secret society. Do you know the name of the communist dictator ?
    ::next-3::
    [iframe]<iframe src="https://www.google.com/maps/embed?pb=!4v1611654008933!6m8!1m7!1sul12_GeuktnKXOY7bhyM4Q!2m2!1d1.297209591208344!2d103.8510773618115!3f154.17743336277744!4f-26.442237411768446!5f0.7820865974627469" width="500" height="500" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>[/iframe]
    ::next-3::
    [img]https://www.paragamix.com/images/Singapur/st-7a-4-diktator.png[/img]`,
    de: `Ich habe mich darum gekümmert. Wir haben den Verräter zur Abschreckung gegen einen der Diktatoren ausgetauscht und im Museum ausgestellt. Der Diktator schwimmt jetzt in der Marina Bay. 
    ::next-2::
    [img]https://www.paragamix.com/images/Singapur/SAM_newspaperG.jpg[/img]
    [url=https://www.paragamix.com/images/Singapur/SAM_newspaperG.jpg]vergrößern[/url]
    ::next-5::
    Für diesen Auftrag erhältst du einen weiteren Teil deines Zertifikats. Für unseren Geheimbund brauchen wir kluge Köpfe. Kennst du den Namen des kommunistischen Diktators ?
    ::next-3::
    [iframe]<iframe src="https://www.google.com/maps/embed?pb=!4v1611654008933!6m8!1m7!1sul12_GeuktnKXOY7bhyM4Q!2m2!1d1.297209591208344!2d103.8510773618115!3f154.17743336277744!4f-26.442237411768446!5f0.7820865974627469" width="500" height="500"></iframe>[/iframe]
    ::next-3::
    [img]https://www.paragamix.com/images/Singapur/st-7a-4-diktator.png[/img]`,
    interaction: (message) => {
      if (
        matchWords(message, [
          'lösung', 'Solución', 'Solution', 'loesung', 'FidelCastro', 'Fidel', 'Castro'
        ])
      )
        return `ST_8_5_Probe`;

      if (
        matchWords(message, [
          "Hilfe",
          "ayuda",
          "aide",
          "help",
        ])
      )
        return `HT_7a_4_Diktator`;

      return 'KT_7a_4_Diktator'
    },
  },
  // 16
  "ST_8_5_Probe": {
    en: `You have passed the [b]probation[/b]. You are worthy to participate in our initiation ceremony. Huang Wang Feng invites you [b]on behalf of the Grand Master [/b]to the Kai Xiang Tang (开 香 堂) of the Kongsi and takes your oath.
    ::next-5::
    [img]https://www.paragamix.com/images/Singapur/schmetterlingE.jpg[/img]
    [url=https://www.paragamix.com/images/Singapur/schmetterlingE.jpg]enlarge[/url]
    ::next-3::
    Choose wisely the two virtues of our brotherhood to which you take your oath.
    [button=https://goo.gl/maps/ScVSiWRL2DLMgVZw6]search easy[/button]
    [button=https://goo.gl/maps/wL2gzFbBRCNEhQzk6]hard[/button]
    `,
    de: `Du hast die [b]Bewährungsprobe[/b] bestanden. Du bist würdig, an unserer Initiationszeremonie teilzunehmen. Huang Wang Feng lädt dich [b]im Auftrag des Großmeisters [/b]zur Kai Xiang Tang (开 香 堂) des Kongsi ein und nimmt dir deinen Eid ab. 
    ::next-5::
    [img]https://www.paragamix.com/images/Singapur/schmetterlingG.jpg[/img]
    [url=https://www.paragamix.com/images/Singapur/schmetterlingG.jpg]vergrößern[/url]
    ::next-3::
    Wähle die beiden Tugenden unserer Bruderschaft, auf die du deinen Eid leistest, mit Bedacht aus.
    [button=https://goo.gl/maps/ScVSiWRL2DLMgVZw6]Suche leicht[/button]
    [button=https://goo.gl/maps/wL2gzFbBRCNEhQzk6]schwer[/button]
    `,
    interaction: (message) => {
      if (
        matchWords(message, [
          'lösung', 'Solución', 'Solution', 'loesung'
        ])
      )
        return `ST_9_6_Zertifikat`;

      if (
        matchWords(message, [
          "Hilfe",
          "ayuda",
          "aide",
          "help",
          'Hinweis'
        ])
      )
        return `HT_8_5_Probe`;

      if (matchWords(message, ['Obedience', 'Loyality'])) return 'ST_9_6_Zertifikat'

      return 'KT_8_5_Probe'
    },
  },
  // 17
  "ST_9_6_Zertifikat": {
    en: `The first duties of a brother are obedience to the brotherhood and loyalty to his brothers. If he is so dishonorable as to violate this law, he can drown in the ocean within a month. His flesh will float on the surface of the water and his bones will be buried in the bottom of the sea. [b]What is the 3-digit code of your certificate?[/b]
    ::next-4::
    [img]https://www.paragamix.com/images/Singapur/st-9-6-zertifikat.png[/img]
    ::next-2::
    [img]https://www.paragamix.com/images/Singapur/st-4b-1-zertifikat1.png[/img]
    ::next-1::
    [img]https://www.paragamix.com/images/Singapur/st-7a-4-diktator.png[/img]
    `,
    de: `Die ersten Pflichten eines Bruders sind Gehorsam gegenüber der Bruderschaft und Treue zu seinen Brüdern. Wenn er so unehrenhaft ist, dass er gegen dieses Gesetz verstößt, kann er innerhalb eines Monats im Ozean ertrinken. Sein Fleisch wird auf der Wasseroberfläche schweben und seine Knochen begraben werden im Meeresboden. [b]Wie lautet der 3stellige Code deines Zertifikats?[/b]
    ::next-4::
    [img]https://www.paragamix.com/images/Singapur/st-9-6-zertifikat.png[/img]
    ::next-2::
    [img]https://www.paragamix.com/images/Singapur/st-4b-1-zertifikat1.png[/img]
    ::next-1::
    [img]https://www.paragamix.com/images/Singapur/st-7a-4-diktator.png[/img]
    `,
    interaction: (message) => {
      if (
        matchWords(message, [
          '174', 'Auflösung', 'Aufloesung', 'resolution', 'résolution', 'resolución', 'lösung', 'loesung', '1 7 4'
        ])
      )
        return `ST_10_7_Moulin`;

      if (
        matchWords(message, [
          "Hilfe",
          "ayuda",
          "aide",
          "help",
          'Hinweis'
        ])
      )
        return `HT_9_6_Zertifikat`;

      return 'KT_9_6_Zertifikat'
    },
  },
  // 18
  "ST_10_7_Moulin": {
    en: `[b]Congratulations[/b]. You are now a Hongmen. Cherish your membership certificate. If you are so shameless as to sell the tokens of the Hong Brotherhood, you may be killed by a tiger or bitten in the eyes by a snake.
    ::next-2::
    In the traitor's pocket was a note.
    ::next-1::
    [img]https://www.paragamix.com/images/Singapur/px_singapurD_kryzio.jpg[/img]
    ::next-1::
    You now have an honorable additional task as a Hongmen: find out the name of the estate of the head of the Kryzio Kalnas gang that is stealing business from our brotherhood. 
    [button=https://bit.ly/kryziokalnas]bit.ly/kryziokalnas[/button]   
    `,
    de: `[b]Ich gratuliere Dir.[/b] Du bist jetzt ein Hongmen. Halte dein Mitgliedszertifikat in Ehren. Wenn du so schamlos bist, die Zeichen der Hong-Bruderschaft zu verkaufen, kannst du von einem Tiger getötet oder von einer Schlange in die Augen gebissen werden.
    ::next-4::
    In der Tasche des Verräters befand sich ein Notizzettel.
    ::next-1::
    [img]https://www.paragamix.com/images/Singapur/px_singapurD_kryzio.jpg[/img]
    ::next-4::
    Du hast nun als Hongmen eine ehrenhafte Zusatzaufgabe: Finde den Namen des Anwesens des Chefs der Kryzio Kalnas Bande heraus, die unserer Bruderschaft das Geschäft streitig macht.
    [button=https://bit.ly/kryziokalnas]bit.ly/kryziokalnas[/button]   
    `,
    interaction: (message) => {
      if (
        matchWords(message, [
          'lösung', 'Solución', 'Solution', 'loesung', 'Moulin', 'LeMoulin'
        ])
      )
        return `ST_11_8_Finale`;

      if (
        matchWords(message, [
          "Hilfe",
          "ayuda",
          "aide",
          "help",
          'Hinweis'
        ])
      )
        return `HT_10_7_Moulin`;

      return 'KT_10_7_Moulin'
    },
  },
  // 19
  "ST_10a_7_Moulin": {
    en: `Super!
    33333315 is correct. The URL is http://bit.ly/33333315
    ::next-3::
    Please enter the name of the building you are looking for.
    [button=http://bit.ly/33333315]33333315[/button]   
    `,
    de: `Super! 
    33333315 ist richtig. Die URL lautet http://bit.ly/33333315
    ::next-3::
    Bitte gib den Namen des gesuchten Gebäudes ein.
    [button=http://bit.ly/33333315]33333315[/button]   
    `,
    interaction: (message) => {
      if (
        matchWords(message, [
          'lösung', 'Solución', 'Solution', 'loesung', 'Moulin', 'LeMoulin'
        ])
      )
        return `ST_11_8_Finale`;

      if (
        matchWords(message, [
          "Hilfe",
          "ayuda",
          "aide",
          "help",
        ])
      )
        return `HT_10_7_Moulin`;
    },
  },
  // 20
  "ST_11_8_Finale": {
    en: `Thank you very much for your help.
    ::next-2::
    You have passed this test as well. 
    The godfather of the Kryziu Kalne Brotherhood, Christian Lueder, has finally been tracked down in faraway France. I am sending a team there. The mission is accomplished. 
    [url=https://www.paragamix.com/en-us/escape_carrie_e]You can learn more about his family here[/url].
    ::next-2::
    You can book more exciting reality escape games via [url=https://www.paragamix.com]www.paragamix.com[/url], for example [url=https://www.paragamix.com/en-us/escape_adele_e]Adele@HorrorCamp[/url].
    ::next-2::
    Follow us on [url=https://www.facebook.com/Paragamix/]Facebook[/url] or [url=https://www.instagram.com/paragamix/]Instagram[/url]. We regularly give away codes among all followers.
    ::next-1::
    Did you like "Secret societies Singapore"?
    [button=interaction-Bewertung gut]yes[/button]
    [button=interaction-Bewertung schlecht]no[/button]
    `,
    de: `Vielen Dank für deine Hilfe.
    ::next-2::
    Du hast auch diese Bewährungsprobe bestanden. 
    Der Pate der Kryziu Kalne Bruderschaft Christian Lueder ist endlich im fernen Frankreich aufgespürt. Ich schicke ein Team dort hin. Die Mission ist somit erfüllt. 
    [url=https://www.paragamix.com/de/escape_carrie_g]Hier kannst du mehr über seine Familie erfahren.[/url]
    ::next-4::
    Wenn du NEUSTART eintippst und danach HALLO CHRISTIAN, kannst du die gleiche Mission aus Sicht des Detektivs erleben.
    ::next-2::
    Weitere spannende Reality Escape Games kannst du buchen über [url=https://www.paragamix.com/de]www.paragamix.com[/url], zum Beispiel [url=https://www.paragamix.com/de/escape_adele_g]Adele@HorrorCamp[/url].
    ::next-2::
    Folge uns auf [url=https://www.facebook.com/Paragamix/]Facebook[/url] oder [url=https://www.instagram.com/paragamix/]Instagram[/url]. Wir verschenken regelmäßig Codes unter allen Followern.
    ::next-3::
    Wie hat dir "Secret Societies Singapur" gefallen?
    [button=interaction-Bewertung gut]gut[/button]
    [button=interaction-Bewertung schlecht]nicht gut[/button]
    `,
    disableInput: true,
    interaction: (message) => {
      if (
        matchWords(message, [
          "Hilfe",
          "ayuda",
          "aide",
          "help",
          'Hinweis'
        ])
      )
        return `HT_11_8_Finale`;

      return 'KT_11_8_Finale'
    },
  },
  // 21
  "Schritt13": {
    en: `Schritt13
    Wenn dir unser Reality Escape Game gefallen hat, freuen wir uns über eine [url=https://g.page/Paragamix/review?gm]Bewertung bei Google[/url]. Weitere spannende Reality Escape Games kannst du buchen über [url=https://www.paragamix.com]www.paragamix.com[/url].
    `,
    de: `Schritt13
    Wenn dir unser Reality Escape Game gefallen hat, freuen wir uns über eine [url=https://g.page/Paragamix/review?gm]Bewertung bei Google[/url]. Weitere spannende Reality Escape Games kannst du buchen über [url=https://www.paragamix.com]www.paragamix.com[/url].`,
    interaction: (message) => {
      if (
        matchWords(message, [
          "Hilfe",
          "ayuda",
          "aide",
          "help",
          'Hinweis'
        ])
      )
        return `Hilfe13`;

      return 'Klammer13'
    },
  },
  // 22
  "F_Schritt_1": {
    en: `Unfortunately, this is not correct. With HELP you get a hint.`,
    de: `Das ist leider nicht richtig. Mit HILFE erhältst du einen Tipp.`,
    interaction: (message) => {
      if (
        matchWords(message, [
          'lösung', 'Solución', 'Solution', 'huang', 'hallo huang'
        ])
      )
        return `ST_2_1_Hong`;

      if (
        matchWords(message, [
          "Hilfe",
          "ayuda",
          "aide",
          "help",
        ])
      )
        return `H_Schritt_1`;

      if (
        matchWords(message, [
          'christian', 'hallochristian', 'holachristian', 'hellochristian'
        ])
      )
        return `*SD_4_1_Level`;

      return 'Klammer1'
    },
  },

  "FT_2_1_Hong": {
    en: `Unfortunately, this is not correct. With HELP you get a hint.`,
    de: `Das ist leider nicht richtig. Mit HILFE erhältst du einen Tipp. `,
    interaction: (message) => {
      if (
        matchWords(message, [
          'lösung', 'Solución', 'Solution', 'hong', 'https://tinyurl.com/hongintra', 'intrahong', 'www.tinyurl.com/hongintra'
        ])
      )
        return `ST_3_1_Intranet`;

      if (
        matchWords(message, [
          "Hilfe",
          "ayuda",
          "aide",
          "help",
        ])
      )
        return `HT_2_1_Hong`;

      return 'KT_2_1_Hong'
    },
  },

  // 23
  "Falsch2": {
    en: `Unfortunately, this is not correct. With HELP you get a hint.    `,
    de: `Das ist leider nicht richtig. Mit HILFE erhältst du einen Tipp. `,
    interaction: (message) => {
      if (
        matchWords(message, [
          'lösung', 'Solución', 'Solution', 'hong', 'https://tinyurl.com/…', 'http://tinyurl.com/i..'
        ])
      )
        return `ST_3_1_Intranet`;

      if (
        matchWords(message, [
          "Hilfe",
          "ayuda",
          "aide",
          "help",
        ])
      )
        return `Hilfe2`;

      return 'KT_2_1_Hong'
    },
  },
  // 24
  "Falsch3 Hauptmenu": {
    en: `Unfortunately, this is not correct. Your membership certificate is not complete until you have completed all orders. Please enter the number of the next job, e.g. #2 for the 2nd job.
    With HELP you get a hint.
    `,
    de: `Das ist leider nicht richtig. Dein Mitgliedszertifikat ist erst komplett, wenn du alle Aufträge erledigt hast. Gib bitte die Nummer des nächsten Auftrags an, z.B. #2 für den 2. Auftrag. 
    Mit HILFE erhältst du einen Tipp.`,
    interaction: (message) => {
      if (
        matchWords(message, [
          "Hilfe",
          "ayuda",
          "aide",
          "help",
        ])
      )
        return `Hilfe Hauptmenu`;

      return 'Klammer3'
    },
  },
  // 25
  "FT_4_1_409": {
    en: `Unfortunately, this is not correct. With HELP you get a hint.`,
    de: `Das ist leider nicht richtig. Mit HILFE erhältst du einen Tipp. `,
    interaction: (message) => {
      if (
        matchWords(message, [
          'lösung', 'Solución', 'Solution', 'loesung', '409'
        ])
      )
        return `ST_40_1_Safe`;

      if (
        matchWords(message, [
          "Hilfe",
          "ayuda",
          "aide",
          "help",
        ])
      )
        return `HT_4_1_409`;

      return 'KT_4_1_409'
    },
  },
  // 26
  "FT_40_1_Safe": {
    en: `Unfortunately, this is not correct. With HELP you get a hint.    `,
    de: `Das ist leider nicht richtig. Mit HILFE erhältst du einen Tipp. `,
    interaction: (message) => {
      if (
        matchWords(message, [
          'lösung', 'Solución', 'Solution', 'loesung', '12837465', '65', '6 5', '6,5'
        ])
      )
        return `ST_4a_1_Telefon`;

      if (
        matchWords(message, [
          "Hilfe",
          "ayuda",
          "aide",
          "help",
        ])
      )
        return `HT_40_1_Safe`;

      return 'KT_40_1_Safe'
    },
  },
  // 27
  "FT_4a_1_Telefon": {
    en: `Unfortunately, this is not correct. With HELP you get a hint.    `,
    de: `Das ist leider nicht richtig. Mit HILFE erhältst du einen Tipp. `,
    interaction: (message) => {
      if (
        matchWords(message, [
          'lösung', 'Solución', 'Solution', 'loesung', '25784'
        ])
      )
        return `ST_4b_1_Zertifikat1`;

      if (
        matchWords(message, [
          "Hilfe",
          "ayuda",
          "aide",
          "help",
        ])
      )
        return `HT_4a_1_Telefon`;

      return 'KT_4a_1_Telefon'
    },
  },
  // 28
  "FT_5_2_Galerie": {
    en: `Unfortunately, this is not correct. With HELP you get a hint.`,
    de: `Das ist leider nicht richtig. Mit HILFE erhältst du einen Tipp. `,
    interaction: (message) => {
      if (
        matchWords(message, [
          'lösung', 'Solución', 'Solution', 'loesung', 'LiuKang', 'Liu', 'Kang'
        ])
      )
        return `ST_5a_2_Bildfehler`;

      if (
        matchWords(message, [
          "Hilfe",
          "ayuda",
          "aide",
          "help",
        ])
      )
        return `HT_5_2_Galerie`;

      return 'KT_5_2_Galerie'
    },
  },
  // 29
  "FT_5a_2_Bildfehler": {
    en: `Unfortunately, this is not correct. With HELP you get a hint.`,
    de: `Das ist leider nicht richtig. Mit HILFE erhältst du einen Tipp. `,
    interaction: (message) => {
      if (
        matchWords(message, [
          'lösung', 'Solución', 'Solution', 'loesung', '5'
        ])
      )
        return `ST_6_3_Restaurant`;

      if (
        matchWords(message, [
          "Hilfe",
          "ayuda",
          "aide",
          "help",
        ])
      )
        return `HT_5a_2_Bildfehler`;

      return 'KT_5a_2_Bildfehler'
    },
  },
  // 30
  "FT_6_3_Restaurant": {
    en: `Unfortunately, this is not correct. With HELP you get a hint.`,
    de: `Das ist leider nicht richtig. Mit HILFE erhältst du einen Tipp. `,
    interaction: (message) => {
      if (
        matchWords(message, [
          'lösung', 'Solución', 'Solution', 'loesung', 'Karotte', 'Karotten', 'Karattenkuchen', 'kuchen', 'zanahoria', 'Cake', 'carotte', 'CarrotCake', 'carrot'
        ])
      )
        return `ST_6a_3_Quittung`;

      if (
        matchWords(message, [
          "Hilfe",
          "ayuda",
          "aide",
          "help",
        ])
      )
        return `HT_6_3_Restaurant`;

      return 'KT_6_3_Restaurant'
    },
  },
  // 31
  "Falsch6_1 #3 Taeter": {
    en: `Yum Cha is the name of the restaurant, but I'm not looking for that. I'm looking for a dish on the menu.  `,
    de: `Yum Cha heisst das Restaurant, aber das suche ich nicht. Ich suche ein Gericht auf der Karte.  `,
    interaction: (message) => {
      if (
        matchWords(message, [
          'zanahoria', 'carotte', 'Carrot', 'Karotte', 'lösung', 'loesung', 'Solution', 'Solución', 'Cake', 'kuchen', 'Karattenkuchen'
        ])
      )
        return `ST_6b_3_Zusatz`;

      if (
        matchWords(message, [
          "Hilfe",
          "ayuda",
          "aide",
          "help",
        ])
      )
        return `HT_6_3_Restaurant`;
    },
  },
  // 32
  "FT_6a_3_Quittung": {
    en: `Unfortunately, this is not correct. With HELP you get a hint.`,
    de: `Das ist leider nicht richtig. Mit HILFE erhältst du einen Tipp. `,
    interaction: (message) => {
      if (
        matchWords(message, [
          'lösung', 'loesung', 'Solution', 'Solución', 'vegetarisch', 'vegetarian', 'végétarien', 'vegetariana', 'vegetariano'
        ])
      )
        return `ST_6b_3_Zusatz`;

      if (
        matchWords(message, [
          "Hilfe",
          "ayuda",
          "aide",
          "help",
        ])
      )
        return `HT_6a_3_Quittung`;

      return 'KT_6a_3_Quittung';
    },
  },
  // 33
  "FT_7_4_Markt": {
    en: `Unfortunately, this is not correct. With HELP you get a hint.`,
    de: `Das ist leider nicht richtig. Mit HILFE erhältst du einen Tipp. `,
    interaction: (message) => {
      if (
        matchWords(message, [
          'lösung', 'loesung', 'Solution', 'Solución', 'Poh', 'Chang', 'Sheng'
        ])
      )
        return `ST_7a_4_Diktator`;

      if (
        matchWords(message, [
          "Hilfe",
          "ayuda",
          'Hinweis',
          "aide",
          "help",
        ])
      )
        return `HT_7_4_Markt`;

      return 'KT_7_4_Markt';
    },
  },
  // 34
  "FT_7a_4_Diktator": {
    en: `Unfortunately, this is not correct. With HELP you get a hint.`,
    de: `Das ist leider nicht richtig. Mit HILFE erhältst du einen Tipp. `,
    interaction: (message) => {
      if (
        matchWords(message, [
          'lösung', 'loesung', 'Solution', 'Solución', 'FidelCastro', 'Fidel', 'Castro'
        ])
      )
        return `ST_8_5_Probe`;

      if (
        matchWords(message, [
          "Hilfe",
          "ayuda",
          "aide",
          "help",
        ])
      )
        return `HT_7a_4_Diktator`;

      return 'KT_7a_4_Diktator';
    },
  },
  // 35
  "FT_8_5_Probe": {
    en: `Unfortunately, this is not correct. With HELP you get a hint.`,
    de: `Das ist leider nicht richtig. Mit HILFE erhältst du einen Tipp. `,
    interaction: (message) => {
      if (
        matchWords(message, [
          'lösung', 'loesung', 'Solution', 'Solución'
        ])
      )
        return `ST_9_6_Zertifikat`;

      if (
        matchWords(message, [
          "Hilfe",
          "ayuda",
          "aide",
          "help",
        ])
      )
        return `HT_8_5_Probe`;


      if (
        matchWords(message, [
          'obedience', 'loyality'
        ])
      )
        return `ST_9_6_Zertifikat`;

      return 'KT_8_5_Probe';
    },
  },
  // 36
  "FT_9_6_Zertifikat": {
    en: `Unfortunately, this is not correct. With HELP you get a hint.`,
    de: `Das ist leider nicht richtig. Mit HILFE erhältst du einen Tipp. `,
    interaction: (message) => {
      if (
        matchWords(message, [
          'lösung', 'loesung', 'Solution', 'Solución', '174', '1 7 4'
        ])
      )
        return `ST_10_7_Moulin`;

      if (
        matchWords(message, [
          "Hilfe",
          "ayuda",
          "aide",
          "help",
        ])
      )
        return `HT_9_6_Zertifikat`;

      return 'KT_9_6_Zertifikat';
    },
  },
  // 37
  "FT_10_7_Moulin": {
    en: `Unfortunately, this is not correct. With HELP you get a hint.`,
    de: `Das ist leider nicht richtig. Mit HILFE erhältst du einen Tipp. `,
    interaction: (message) => {
      if (
        matchWords(message, [
          'lösung', 'loesung', 'Solution', 'Solución', 'Moulin', 'LeMoulin'
        ])
      )
        return `ST_11_8_Finale`;

      if (
        matchWords(message, [
          "Hilfe",
          "ayuda",
          "aide",
          "help",
        ])
      )
        return `HT_10_7_Moulin`;

      return 'KT_10_7_Moulin';
    },
  },
  // 38
  "FT_11_8_Finale": {
    en: `Unfortunately, this is not correct. I need the name of the building where he is staying. 
    With HELP you get a hint.`,
    de: `Das ist leider nicht richtig. Ich brauche den Namen des Gebäudes, in dem er sich aufhält. 
    Mit HILFE erhältst du einen Tipp.`,
    interaction: (message) => {
      if (
        matchWords(message, [
          "Hilfe",
          "ayuda",
          "aide",
          "help",
        ])
      )
        return `HT_11_8_Finale`;

      return 'KT_11_8_Finale';
    },
  },
  // 39
  "Falsch12": {
    en: `Unfortunately, this is not correct. With HELP you get a hint.`,
    de: `Das ist leider nicht richtig. Mit HILFE erhältst du einen Tipp. `,
    interaction: (message) => {
      if (
        matchWords(message, [
          'lösung', 'Solución', 'Solution', 'loesung', 'Moulin', 'LeMoulin'
        ])
      )
        return `*Schritt13`;

      if (
        matchWords(message, [
          "Hilfe",
          "ayuda",
          "aide",
          "help",
        ])
      )
        return `Hilfe12`;

      return 'Klammer12';
    },
  },
  // 40
  "Falsch13": {
    en: `Unfortunately, this is not correct. With HELP you get a hint.`,
    de: `Das ist leider nicht richtig. Mit HILFE erhältst du einen Tipp. `,
    interaction: (message) => {
      if (
        matchWords(message, [
          "Hilfe",
          "ayuda",
          "aide",
          "help",
        ])
      )
        return `Hilfe13`;

      return 'Klammer13';
    },
  },
  // 41
  "H_Schritt_1": {
    en: `[b]Help: [/b]If you are a perpetrator write HELLO HUANG
if you are a detective write HELLO CHRISTIAN`,
    de: `[b]Hilfe: [/b]Wenn du Täter bist schreibe HALLO HUANG
wenn du Detektiv bist schreibe HALLO CHRISTIAN.`,
    interaction: (message) => {
      if (
        matchWords(message, [
         "HELLO HUANG", "HALLO HUANG", "Hallo Huang", "Hello Huang", "lösung", "Solución" , "Solution" , "loesung", "huang", "hallohuang"
        ])
      )
        return `ST_2_1_Hong`;

      if (
        matchWords(message, [
         "HELLO CHRISTIAN", "HALLO CHRISTIAN", "Hallo Christian", "Hello Christian", "Christian","HalloChristian", "hellochristian", "halochristian"
        ])
      )
        return `*SD_4_1_Level`;

      return 'Klammer1';
    },
  },
  "HT_2_1_Hong": {
    en: `[b]Help: [/b]
    The numbers 3-8-20-1 must first be translated into Chinese characters. Use the table for this purpose. The characters must then be put together to make the symbol you are looking for - the sign of the Brotherhood. You can also find this in the table.  
    With SOLUTION you can skip this puzzle.`,
    de: `[b]Hilfe: [/b]
    Die Zahlen 3-8-20-1 müssen zunächst in chinesische Schriftzeichen übersetzt werden. Nutze dazu die Tabelle. Die Schriftzeichen müssen dann so zusammengefügt werden, dass sie das gesuchte Symbol ergeben - das Zeichen der Bruderschaft. Dieses findest du ebenfalls in der Tabelle.  
    Mit LÖSUNG kannst du dieses Rätsel überspringen.`,
    interaction: (message) => {
      if (
        matchWords(message, [
          'lösung', 'Solución', 'Solution', 'loesung, Hong', 'https://tinyurl.com/hongintra', 'www.tinyurl.com/hongintra', 'hongintra'
        ])
      )
        return `ST_3_1_Intranet`;

      return 'KT_2_1_Hong';
    },    
  },
  // 42
  "Hilfe2": {
    en: `[b]Help: [/b] The numbers 3-8-20-1 must first be translated into Chinese characters. Use the table for this purpose. The characters must then be put together to make the symbol you are looking for - the sign of the Brotherhood. You can also find this in the table. With SOLUTION you can skip this puzzle.`,
    de: `[b]Hilfe: [/b]
    Die Zahlen 3-8-20-1 müssen zunächst in chinesische Schriftzeichen übersetzt werden. Nutze dazu die Tabelle. Die Schriftzeichen müssen dann so zusammengefügt werden, dass sie das gesuchte Symbol ergeben - das Zeichen der Bruderschaft. Dieses findest du ebenfalls in der Tabelle.  
    Mit LÖSUNG kannst du dieses Rätsel überspringen.`,
    interaction: (message) => {
      if (
        matchWords(message, [
          "lösung",
          "Solución",
          "Solution",
          "loesung",
          "Hong",
          "https://tinyurl.com/…",
          "http://tinyurl.com/i..."
        ])
      )
        return `ST_3_1_Intranet`;

      return 'KT_2_1_Hong';
    },
  },
  // 43
  "Hilfe3": {
    en: `Keine Hilfe vorhanden.`,
    de: `Keine Hilfe vorhanden.`,
    interaction: (message) => {
      return 'Klammer3';
    },
  },
  // 44
  "HT_4_1_409": {
    en: `[b]Help: [/b] Look around the hotel and find the room where the photo was taken. To change floors, you can find the floor number on Google Maps on the left or right side of the screen. Then select the number of the floor. With SOLUTION you can skip this puzzle.`,
    de: `[b]Hilfe: [/b]
    Sieh dich im Hotel um und suche den Raum, in dem das Foto gemacht wurde. Um das Stockwerk zu wechseln, findest du bei Google Maps auf der linken oder rechten Bildschirmseite die Nummer des Stockwerks. Wähle dann die Nummer der Etage aus.
    Mit LÖSUNG kannst du dieses Rätsel überspringen.`,
    interaction: (message) => {
      if (
        matchWords(message, [
          "lösung",
          "Solución",
          "Solution",
          "loesung",
          "409"
        ])
      )
        return `ST_40_1_Safe`;

      return 'KT_4_1_409';
    },
  },
  // 45
  "HT_5_2_Galerie": {
    en: `[b]Help: [/b] Click on the button and take a close look around the museum. You will surely quickly find the exhibition with art from Bali. The name of the artist is displayed on the wall of the exhibition space. Enter the first name and the last name here. With SOLUTION you can skip this puzzle.`,
    de: `[b]Hilfe: [/b]
    Klicke auf den Button und sieh dich genau im Museum um. Du findest sicher schnell die Ausstellung mit Kunst aus Bali. Der Name der Künstlerin ist an der Wand der Ausstellungsfläche abgebildet. Gib hier den Vornamen und den Nachnamen ein.
    Mit LÖSUNG kannst du dieses Rätsel überspringen.`,
    interaction: (message) => {
      if (
        matchWords(message, [
          "lösung",
          "Solución",
          "Solution",
          "loesung",
          "LiuKang",
          "Liu",
          "Kang"
        ])
      )
        return `ST_5a_2_Bildfehler`;

      return 'KT_5_2_Galerie';
    },
  },
  // 46
  "HT_5a_2_Bildfehler": {
    en: `[b]Help: [/b] [url=https://goo.gl/maps/ccygvQeGfLkggyTk7]Look around the museum[/url] and find the picture that was replaced by the copy. Find the differences from the photo above and enter the number of differences in the chat. I have already found 2 mistakes in the grass alone.`,
    de: `[b]Hilfe: [/b]
    [url=https://goo.gl/maps/ccygvQeGfLkggyTk7]Sieh dich im Museum um[/url] und finde das Bild, das durch die Kopie ersetzt wurde. Suche die Unterschiede zu dem oben abgebildeten Foto und gib die Anzahl der Unterschiede im Chat ein. Alleine im Gras habe ich schon 2 Fehler gefunden.`,
    interaction: (message) => {
      if (
        matchWords(message, [
          "lösung",
          "Solución",
          "Solution",
          "loesung",
          "5"
        ])
      )
        return `ST_6_3_Restaurant`;

      return 'KT_5a_2_Bildfehler';
    },
  },
  // 47
  "HT_40_1_Safe": {
    en: `[b]Help: [/b] Next to the entrance door of the hotel room, our brother left a note on how to open the safe. The last two digits are missing. In this task you have to recognize a pattern and continue the row according to the pattern. Look closely at the position of the black square on the wheels. In the first two images, the wheel rotates one unit to the right. On the 3rd picture, another wheel turns one unit to the left. On the 5th picture, this wheel turns one more unit to the left. With SOLUTION you can skip this puzzle.`,
    de: `[b]Hilfe: [/b]
    Neben der Eingangstür des Hotelzimmers hat unser Bruder einen Hinweis hinterlassen, wie man den Safe öffnet. Es fehlen die letzten beiden Ziffern.
    Bei dieser Aufgabe musst du ein Muster erkennen und die Reihe entsprechend dem Muster fortsetzen. Sieh dir genau die Stellung des schwarzen Quadrats auf den Rädern an. In den ersten beiden Bildern dreht sich das Rad um eine Einheit nach rechts. Auf dem 3. Bilde dreht sich ein weiteres Rad um eine Einheit nach links. Auf dem 5. Bild dreht sich dieses Rad um eine weitere Einheit nach links.
    Mit LÖSUNG kannst du dieses Rätsel überspringen.`,
    interaction: (message) => {
      if (
        matchWords(message, [
          "lösung",
          "Solución",
          "Solution",
          "loesung",
          "12837465",
          "65",
          "6 5",
          "6,5"
        ])
      )
        return `ST_4a_1_Telefon`;

      return 'KT_40_1_Safe';
    },
  },
  // 48
  "HT_4a_1_Telefon": {
    en: `[b]Help: [/b] Take a look around the Hong intranet. In the first post, besides the grandmaster, you can also see a table with numbers. Do the outlines of the table remind you of the outlines of the code? Now you just have to match the outlines correctly. With SOLUTION you can skip this puzzle.`,
    de: `[b]Hilfe: [/b]
    Schau dich um im Hong Intranet. Im ersten Beitrag ist neben dem Großmeister auch eine Tabelle mit Zahlen zu sehen. Erinnern dich die Umrisse der Tabelle an die Umrisse des Codes? Jetzt musst du nur noch die Umrisse richtig zuordnen. 
    Mit LÖSUNG kannst du dieses Rätsel überspringen.`,
    interaction: (message) => {
      if (
        matchWords(message, [
          "lösung",
          "Solución",
          "Solution",
          "loesung",
          "25784"
        ])
      )
        return `ST_4b_1_Zertifikat1`;

      return 'KT_4a_1_Telefon';
    },
  },
  // 49
  "HT_6_3_Restaurant": {
    en: `[b]Help: [/b] Click on the RESTAURANT button and follow the road for a few steps, then turn left. On the right you will see the Galaxy Tattoo store and across the street the restaurant you are looking for. Google the restaurant in Singapore and go to the website menu. There you will find the dish that is pictured on the food blog. With SOLUTION you can skip this puzzle.`,
    de: `[b]Hilfe: [/b]
    Klicke auf den Button RESTAURANT und folge der Strasse einige Schritte, biege dann nach links ab. Rechts siehst du den Laden von Galaxy Tattoo und gegenüber das gesuchte Restaurant. Google das Restaurant in Singapur und geh auf die Menükarte der Webseite. Dort findest du das Gericht, das auf dem Food Blog abgebildet ist. 
    Mit LÖSUNG kannst du dieses Rätsel überspringen.`,
    interaction: (message) => {
      if (
        matchWords(message, [
          "lösung",
          "Solución",
          "Solution",
          "loesung",
          "Karotte",
          "Karotten",
          "Karattenkuchen",
          "kuchen",
          "zanahoria",
          "Cake",
          "carotte",
          "CarrotCake",
          "carrot"
        ])
      )
        return `ST_6a_3_Quittung`;

      return 'KT_6_3_Restaurant';
    },
  },
  // 50
  "HT_6a_3_Quittung": {
    en: `[b]Help: [/b] You have already found the menu of the restaurant. Now compare the dishes on the bill with those on the menu. What do you notice? What we are looking for is a common feature that unites all the dishes (except that they come from Chinese cuisine).`,
    de: `[b]Hilfe: [/b]
    Die Speisekarte des Restaurants hast du ja bereits gefunden. Vergleiche nun die Gerichte auf der Rechnung mit denen auf der Karte. Was fällt dir auf? Gesucht ist eine Gemeinsamkeit, die alle Gerichte verbindet (außer dass sie der chinesischen Küche entstammen).`,
    interaction: (message) => {
      if (
        matchWords(message, [
          "lösung",
          "loesung",
          "vegetarisch",
          "solution",
          "vegetarian",
          "végétarien",
          "vegetariana",
          "vegetariano"
        ])
      )
        return `ST_6b_3_Zusatz`;

      return 'ST_6a_3_Quittung';
    },
  },
  // 51
  "HT_7_4_Markt": {
    en: `[b]Help: [/b] [url=https://goo.gl/maps/34ufySaD3YmVTmme9]Follow the passage to the end[/url]. On the right side you will find the store of the traitor you are looking for. Enter the name shown on the store sign. With SOLUTION you can skip this puzzle.`,
    de: `[b]Hilfe: [/b]
    [url=https://goo.gl/maps/34ufySaD3YmVTmme9]Folge dem Gang bis zum Ende[/url]. Auf der rechten Seite findest du den gesuchten Laden des Verräters. Gib den auf dem Ladenschild abgebildeten Namen ein. 
    Mit LÖSUNG kannst du dieses Rätsel überspringen.`,
    interaction: (message) => {
      if (
        matchWords(message, [
          "lösung",
          "loesung",
          "Solución",
          "Solution",
          "poh",
          "chang",
          "sheng"
        ])
      )
        return `ST_7a_4_Diktator`;

      return 'KT_7_4_Markt';
    },
  },
  // 52
  "HT_7a_4_Diktator": {
    en: `[b]Help: [/b] One of the dictators exhibited in the museum was replaced by the traitor. It is a communist leader from Cuba. With SOLUTION you can skip this puzzle.`,
    de: `[b]Hilfe: [/b]
    Einer der im Museum ausgestellten Diktatoren wurde durch den Verräter ausgetauscht. Es handelt sich um einen kommunistischen Führer aus Kuba.
    Mit LÖSUNG kannst du dieses Rätsel überspringen.`,
    interaction: (message) => {
      if (
        matchWords(message, [
          "lösung",
          "loesung",
          "Solución",
          "Solution",
          "FidelCastro",
          "Fidel",
          "Castro"
        ])
      )
        return `ST_8_5_Probe`;

      return 'KT_7a_4_Diktator';
    },
  },
  // 53
  "HT_8_5_Probe": {
    en: `[b]Help:[/b] Look around the museum and find the picture with the butterflies. You can find the right butterflies in the Hong Intranet on the first picture about the history of the Brotherhood. Type the two virtues that belong to the butterflies. With SOLUTION you can skip this puzzle.`,
    de: `[b]Hilfe:[/b] 
    Sieh dich im Museum um und finde das Bild mit den Schmetterlingen. Die richtigen Schmetterlinge findest du im Hong Intranet auf dem ersten Bild zur Geschichte der Bruderschaft. Tippe die beiden Tugenden ein, die zu den Schmetterlingen gehören. 
    Mit LÖSUNG kannst du dieses Rätsel überspringen.`,
    interaction: (message) => {
      if (
        matchWords(message, [
          "lösung",
          "loesung",
          "Solución",
          "Solution"
        ])
      )
        return `ST_9_6_Zertifikat`;

      if (
        matchWords(message, [
          "gehorsam",
          "treue"
        ])
      )
        return `ST_9_6_Zertifikat`;

      return 'KT_8_5_Probe';
    },
  },
  // 54
  "HT_9_6_Zertifikat": {
    en: `[b]Help: [/b] Look at the table of Chinese characters on the Hong intranet and translate the characters in the middle of the member certificate by the corresponding digits. All numbers of a row can be added to 15. The digits marked with ? give the solution word. With SOLUTION you can skip this puzzle.`,
    de: `[b]Hilfe: [/b]
    Sieh dir die Tabelle mit chinesischen Schriftzeichen im Hong Intranet an und übersetze die Schriftzeichen in der Mitte des Mitglied-Zertifikates durch die entsprechenden Ziffern. Alle Zahlen einer Reihe lassen sich zu 15 ergänzen. Die mit ? gekennzeichneten Ziffern ergeben das Lösungswort.
    Mit LÖSUNG kannst du die gesamte Mission lösen und das Spiel beenden.`,
    interaction: (message) => {
      if (
        matchWords(message, [
          "lösung",
          "loesung",
          "Solución",
          "Solution",
          "174",
          "1 7 4"
        ])
      )
        return `ST_10_7_Moulin`;

      return 'KT_9_6_Zertifikat';
    },
  },
  // 55
  "HT_10_7_Moulin": {
    en: `[b]Help:[/b] 1. look around the room carefully. Press the arrow to start the projector. On the screen you will see a Bitcoin, a hemp leaf and a dollar sign. 3. in the room you will find a picture with dollars. Count up the value of the dollars. On the canvas, follow the path from the dollars to the corresponding letter. 4. in the room you will find a hemp plant. Count the leaves. On the canvas, follow the path from the hemp leaf to the corresponding letter. In the room you will find a stack of BitCoin coins. Count the coins. On the canvas, follow the path from the Bitcoins to the corresponding letter. 6. put A,B,C into the formula on the FlipChart and type the URL into your web browser. 7. what is the name of the building?`,
    de: `[b]Hilfe:[/b]
    1. Sieh dich genau im Raum um. Drücke den Pfeil, um den Beamer zu starten. 
    2. Auf der Leinwand siehst Du einen Bitcoin, ein Hanfblatt und ein Dollar-Zeichen.
    3. Im Raum findest Du ein Bild mit Dollar-Noten. Zähle den Wert aller Dollars zusammen. Folge auf der Leinwand dem Pfad von den Dollars zum entsprechenden Buchstaben.
    4. Im Raum findest Du eine Hanfpflanze. Zähle die Blätter. Folge auf der Leinwand dem Pfad von dem Hanfblatt zum entsprechenden Buchstaben.
    5. Im Raum findest Du einen Stapel Bitcoin Münzen. Zähle die Münzen. Folge auf der Leinwand dem Pfad von den Bitcoins zum entsprechenden Buchstaben.
    6. Setze die Werte für A,B,C in die Formel auf dem FlipChart ein und gib die URL in deinen Webbrowser ein.
    7. Wie lautet der Name des Gebäudes?`,
    interaction: (message) => {
      if (
        matchWords(message, [
          "lösung",
          "loesung",
          "Solución",
          "Solution",
          "Moulin",
          "LeMoulin"
        ])
      )
        return `ST_11_8_Finale`;

      return 'KT_10_7_Moulin';
    },
  },
  // 56
  "HT_11_8_Finale": {
    en: `Hilfe11`,
    de: `Hilfe11`,
    interaction: (message) => {
      return 'KT_11_8_Finale';
    },
  },
  // 57
  "Hilfe12": {
    en: `Hilfe12`,
    de: `Hilfe12`,
    interaction: (message) => {
      if (
        matchWords(message, [
          "lösung",
          "loesung",
          "Solución",
          "Solution"
        ])
      )
        return `Schritt13`;

      return 'Klammer12';
    },
  },
  // 58
  "Hilfe13": {
    en: `Hilfe13`,
    de: `Hilfe13`,
    interaction: (message) => {
      return 'Klammer13';
    },
  },
  // 59
  "Hilfe Hauptmenu": {
    en: `[b]Help:[/b] You must first complete all four orders. When you have collected all 3 parts of the certificate, look at the table of Chinese characters on the Hong intranet and replace the characters in the middle of the member certificate with the corresponding digits. All numbers of a row can be added to 15. The digits marked with ? give the solution word. Now enter the number of the next job, e.g. #1 Use RESOLUTION to resolve the entire mission and end the game.`,
    de: `[b]Hilfe:[/b]
    Du musst zunächst alle vier Aufträge erledigen. Wenn du alle 3 Teile des Zertifikats gesammelt hast sieh dir die Tabelle mit chinesischen Schriftzeichen im Hong Intranet an und ersetze die Schriftzeichen in der Mitte des Mitglied-Zertifikates durch die entsprechenden Ziffern. Alle Zahlen einer Reihe lassen sich zu 15 ergänzen. Die mit ? gekennzeichneten Ziffern ergeben das Lösungswort.
    Gib jetzt die Nummer des nächsten Auftrags ein, z.B. #1
    Mit AUFLOESUNG löst du die gesamte Mission auf und beendest das Spiel.`,
    interaction: (message) => {
      if (
        matchWords(message, [
          'Auflösung', 'Aufloesung', 'resolution', 'résolution', 'resolución', '174'
        ])
      )
        return `ST_10_7_Moulin`;

      return 'Klammer3';
    },
  },
  // 60
  "Klammer1": {
    en: `To whom is your greeting directed?`,
    de: `An wen richtet sich deine Begrüßung?`,
    interaction: (message) => {
      if (
        matchWords(message, [
          "lösung",
          "loesung",
          "Solución",
          "Solution",
          "holahuang",
          "hellohuang",
          "huang"
        ])
      )
        return `ST_2_1_Hong`;

      if (
        matchWords(message, [
          "Ayuda",
          "Hilfe",
          "Aide",
          "help"
        ])
      )
        return `H_Schritt_1`;

      if (
        matchWords(message, [
          "christian",
          "hallochristian",
          "cristian",
          "holachristian",
          "hellochristian"
        ])
      )
        return `*SD_4_1_Level`;

      return 'F_Schritt_1';
    },
  },
  // 61
  "KT_2_1_Hong": {
    en: `If that's your answer, I'm afraid it's wrong.`,
    de: `Falls das deine Antwort ist, ist sie leider falsch.`,
    interaction: (message) => {
      if (
        matchWords(message, [
          "lösung",
          "loesung",
          "Solución",
          "Solution",
          "Hong",
          "https://tinyurl.com/...",
          "http://tinyurl.com/i..."
        ])
      )
        return `ST_3_1_Intranet`;

      if (
        matchWords(message, [
          "Ayuda",
          "Hilfe",
          "Aide",
          "help"
        ])
      )
        return `HT_2_1_Hong`;

      return 'FT_2_1_Hong';
    },
  },
  // 62
  "Klammer3": {
    en: `If that's your answer, I'm afraid it's wrong. Type the number of the job, e.g. Job #1.`,
    de: `Falls das deine Antwort ist, ist sie leider falsch. Tippe die Nummer des Jobs ein, z.B. Job #1.`,
    interaction: (message) => {
      if (
        matchWords(message, [
          "Ayuda",
          "Hilfe",
          "Aide",
          "help"
        ])
      )
        return `ST_4_1_409`;

      return 'Falsch3 Hauptmenu';
    },
  },
  // 63
  "KT_4_1_409": {
    en: `If that's your answer for job #1, I'm afraid it's wrong.`,
    de: `Wenn das deine Antwort für Job #1 ist, ist sie leider falsch.`,
    interaction: (message) => {
      if (
        matchWords(message, [
          "lösung",
          "loesung",
          "Solución",
          "Solution",
          "409"
        ])
      )
        return `ST_40_1_Safe`;

      if (
        matchWords(message, [
          "Ayuda",
          "Hilfe",
          "Aide",
          "help"
        ])
      )
        return `HT_4_1_409`;

      return 'FT_4_1_409';
    },
  },
  // 64
  "KT_40_1_Safe": {
    en: `This is not the two-digit number for the safe.`,
    de: `Das ist nicht die zweistellige Nummer für den Safe.`,
    interaction: (message) => {
      if (
        matchWords(message, [
          "lösung",
          "loesung",
          "Solución",
          "Solution",
          "12837465",
          "65",
          "(6,5)",
          "6 5"
        ])
      )
        return `ST_4a_1_Telefon`;

      if (
        matchWords(message, [
          "ayuda",
          "hilfe",
          "aide",
          "help"
        ])
      )
        return `HT_40_1_Safe`;

      return 'FT_40_1_Safe';
    },
  },
  // 65
  "KT_4a_1_Telefon": {
    en: `This is not the phone number you are looking for.`,
    de: `Das ist nicht die gesuchte Telefonnummer.`,
    interaction: (message) => {
      if (
        matchWords(message, [
          "lösung",
          "loesung",
          "Solución",
          "Solution",
          "25784"
        ])
      )
        return `ST_4b_1_Zertifikat1`;

      if (
        matchWords(message, [
          "ayuda",
          "hilfe",
          "aide",
          "help"
        ])
      )
        return `HT_4a_1_Telefon`;

      return 'FT_4a_1_Telefon';
    },
  },
  // 66
  "KT_5_2_Galerie": {
    "en": `If that's your answer for Job #2, I'm afraid it's wrong.`,
    "de": `Wenn das deine Antwort für Job #2 ist, ist sie leider falsch.`,
    "interaction": (message) => {
      if (matchWords(message, ['lösung', 'loesung', 'Solución', 'Solution', 'LiuKang', 'Liu', 'Kang'])) return 'ST_5a_2_Bildfehler';
      if (matchWords(message, ['Ayuda', 'Hilfe', 'Aide', 'help'])) return 'HT_5_2_Galerie';
      return 'FT_5_2_Galerie';
    }
  },
  // 67
  "KT_5a_2_Bildfehler": {
    "en": `I am looking for the number of differences in the painting copy. This is not the right number.`,
    'de': `Ich suche die Anzahl der Unterschiede in der Gemäldekopie. Das ist nicht die richtige Anzahl. `,
    "interaction": (message) => {
      if (matchWords(message, ['lösung', 'loesung', 'Solución', 'Solution', '5'])) return 'ST_6_3_Restaurant';
      if (matchWords(message, ['ayuda', 'Hilfe', 'aide', 'help'])) return 'HT_5a_2_Bildfehler';
      return 'FT_5a_2_Bildfehler';
    }
  },
  // 68
  "KT_6_3_Restaurant": {
    "en": `If that's your answer for job #3, I'm afraid it's wrong.`,
    "de": `Wenn das deine Antwort für Job #3 ist, ist sie leider falsch.`,
    "interaction": (message) => {
      if (matchWords(message, ['lösung', 'loesung', 'Solución', 'Solution', 'CarrotCake', 'Cake', 'Carrot', 'Karotten', 'Karotte', 'Kuchen', 'Zanahoria', 'Carotte'])) return 'ST_6a_3_Quittung';
      if (matchWords(message, ['Ayuda', 'Hilfe', 'Aide', 'help'])) return 'HT_6_3_Restaurant';
      return 'FT_6_3_Restaurant';
    }
  },
  // 69
  "KT_6a_3_Quittung": {
    "en": `Unfortunately, this is not what I was looking for. Compare the dishes on the bill with those on the menu. What do you notice?`,
    'de': `Das ist leider nicht das was ich gesucht habe. Vergleiche die Gerichte auf der Rechnung mit denen auf der Speisekarte. Was fällt dir auf?`,
    "interaction": (message) => {
      if (matchWords(message, ['lösung', 'loesung', 'Solución', 'Solution', 'végétarien', 'vegetariano', 'vegetarian', 'vegetarisch', 'vegetariana'])) return 'ST_6b_3_Zusatz';
      if (matchWords(message, ['ayuda', 'Hilfe', 'aide', 'help'])) return 'HT_6a_3_Quittung';
      return 'FT_6a_3_Quittung';
    }
  },
  // 70
  "KT_7_4_Markt": {
    "en": `If that's your answer, I'm afraid it's wrong.`,
    'de': `Wenn das deine Antwort ist, ist sie leider falsch.`,
    "interaction": (message) => {
      if (matchWords(message, ['lösung', 'loesung', 'Solución', 'Solution', 'Poh', 'Chang', 'Sheng'])) return 'ST_7a_4_Diktator';
      if (matchWords(message, ['ayuda', 'Hilfe', 'aide', 'help'])) return 'HT_7_4_Markt';
      return 'FT_7_4_Markt';
    }
  },
  // 71
  "KT_7a_4_Diktator": {
    "en": `If that's your answer for job #4, I'm afraid it's wrong.`,
    "de": `Wenn das deine Antwort für Job #4 ist, ist sie leider falsch.`,
    "interaction": (message) => {
      if (matchWords(message, ['lösung', 'Solución', 'Solution', 'loesung', 'FidelCastro', 'Fidel', 'Castro'])) return 'ST_8_5_Probe';
      if (matchWords(message, ['ayuda', 'Hilfe', 'aide', 'help'])) return 'HT_7a_4_Diktator';
      return 'FT_7a_4_Diktator';
    }
  },
  // 72
  "KT_8_5_Probe": {
    "en": `If that's your answer for job #5, I'm afraid it's wrong.`,
    'de': `Wenn das deine Antwort für Job #4 ist, ist sie leider falsch.`,
    "interaction": (message) => {
      if (matchWords(message, ['lösung', 'Solución', 'Solution', 'loesung'])) return 'ST_9_6_Zertifikat';
      if (matchWords(message, ['ayuda', 'Hilfe', 'aide', 'help'])) return 'HT_8_5_Probe';
      if (matchWords(message, ['Obedience', 'Loyalty'])) return 'ST_9_6_Zertifikat';
      return 'FT_8_5_Probe';
    }
  },
  // 73
  "KT_9_6_Zertifikat": {
    "en": `This is not the number that comes out of the puzzle. Put the puzzle pieces together. The question marks make the number you are looking for.`,
    'de': `Das ist nicht die Zahl, die sich aus dem Puzzle ergibt. Setze die Puzzle-Stücke zusammen. Die Fragezeichen ergeben die Zahl, nach der du suchst. `,
    "interaction": (message) => {
      if (matchWords(message, ['lösung', 'Solución', 'Solution', 'loesung', '174', '1 7 4'])) return 'ST_10_7_Moulin';
      if (matchWords(message, ['ayuda', 'Hilfe', 'aide', 'help'])) return 'HT_9_6_Zertifikat';
      return 'FT_9_6_Zertifikat';
    }
  },
  // 74
  "KT_10_7_Moulin": {
    "en": `If that's your answer, I'm afraid it's wrong. Take a good look around the room.`,
    de: `Wenn das deine Antwort ist, ist sie leider falsch. Sieh dich genau im Raum um.`,
    "interaction": (message) => {
      if (matchWords(message, ['lösung', 'Solución', 'Solution', 'loesung', 'Moulin', 'LeMoulin'])) return 'ST_11_8_Finale';
      if (matchWords(message, ['ayuda', 'Hilfe', 'aide', 'help'])) return 'HT_10_7_Moulin';
      return 'FT_10_7_Moulin';
    }
  },
  // 75
  "KT_11_8_Finale": {
    "en": `If that's your answer, I'm afraid it's wrong.`,
    de: `Wenn das deine Antwort ist, ist sie leider falsch.`,
    "interaction": (message) => {
      if (matchWords(message, ['ayuda', 'Hilfe', 'aide', 'help'])) return 'HT_11_8_Finale';
      return 'FT_11_8_Finale';
    }
  },
  // 76
  "Klammer12": {
    "en": `If that's your answer, I'm afraid it's wrong.`,
    de: `Wenn das deine Antwort ist, ist sie leider falsch.`,
    "interaction": (message) => {
      if (matchWords(message, ['lösung', 'Solución', 'Solution', 'loesung'])) return '*Schritt13';
      if (matchWords(message, ['ayuda', 'Hilfe', 'aide', 'help'])) return 'Hilfe12';
      return 'Falsch12';
    }
  },
  // 77
  "Klammer13": {
    "en": `If that's your answer, I'm afraid it's wrong.`,
    de: `Wenn das deine Antwort ist, ist sie leider falsch.`,
    "interaction": (message) => {
      if (matchWords(message, ['ayuda', 'Hilfe', 'aide', 'help'])) return 'Hilfe13';
      return 'Falsch13';
    }
  },
  // 78
  "Bewertung gut": {
    "en": `Thank you for trying our online Escape game. We put a lot of heart and soul into it and we're very happy that you liked it. Please be so kind and briefly give a short [url=https://g.page/Paragamix/review?gm]review on Google[/url]. This helps us to become better known and to develop more games.`,
    de: `Vielen Dank, dass du unser Online Escape Spiel ausprobiert hast. Wir haben viel Herzblut hineingesteckt und es freut uns sehr, dass es dir gefallen hat. Bitte sei so nett und gib kurz [b]eine kurze [url=https://g.page/Paragamix/review?gm]Bewertung bei Google[/url] [/b]ab. Das hilft uns, bekannter zu werden und weitere Spiele zu entwickeln. `,
    disableInput: true,
    "interaction": () => {

    }
  },
  // 79
  "Bewertung schlecht": {
    "en": `Thank you for trying our online escape game. It's a pity that you didn't like it. We would like to adapt the game even better to your requirements and would be very pleased to receive your feedback. Please send an email to <a href= "mailto:feedback@paragamix.com">feedback@paragamix.com</a>. For beginners we recommend [url=https://www.paragamix.com/en-us/escape_adele_e]Adele[/url] or the [url=https://www.paragamix.com/en-us/escape_jerez_e]Sherry adventure[/url].`,
    de: `Schade, dass es dir nicht gefallen hat. Vielen Dank, dass du es ausprobiert hast. Wir möchten das Spiel gerne noch besser auf deine Anforderungen anpassen und freuen uns über dein Feedback an <a href= "mailto:feedback@paragamix.com">feedback@paragamix.com</a>. Einsteigern empfehlen wir [url=https://www.paragamix.com/de/escape_adele_g]Adele[/url] oder das [url=https://www.paragamix.com/de/escape_jerez_g]Sherry Abenteuer[/url].`,
    disableInput: true,
    "interaction": () => {

    }
  },
  // 80
  "*SD_4_1_Level": {
    "en": `Thank you for trying to help me.
  ::next-2::
  I am Christian and run several businesses in Singapore. Members of the Hong Brotherhood are on my tail and threaten my life because I don't pay protection money to them. In the last few days there have been several attacks and robberies that I attribute to the Hong Brotherhood. Please support the Singapore Police to solve the cases and put the perpetrators behind bars to prevent the assassination against me.
  
  ::next-2::
  If you have experience with cases of this type, choose the tricky version, otherwise the medium one. Good luck!
  
  [button=interaction-*SD_4_1_H_Intranet]tricky[/button]
  [button=interaction-*SD_4_1_E_Intranet]medium[/button]
  `,
    de: `Danke, dass du mir helfen willst. 
  ::next-2::
  Ich bin Christian und betreibe mehrere Geschäfte in Singapur. 
  Mitglieder der Hong-Bruderschaft sind mir auf den Fersen und bedrohen mein Leben, weil ich kein Schutzgeld an sie bezahle. In den letzen Tagen gab es mehrere Anschläge und Raubdelikte, die ich der Hong-Bruderschaft zurechne. Bitte unterstütze die Polizei Singapur dabei, die Fälle aufzuklären und die Täter hinter Gitter zu bringen, damit das Attentat gegen mich verhindert wird.
  ::next-2::
  Hast du Erfahrungen mit Fällen dieser Art, dann wähle die knifflige Version, sonst die mittlere. Viel Erfolg!
  [button=interaction-*SD_4_1_H_Intranet]knifflig[/button]
  [button=interaction-*SD_4_1_E_Intranet]mittel[/button]
  `,
    disableInput: true,
    "interaction": (message) => {
      return '*KD_4_1_Intranet';
    }
  },
  // 81
  "*SD_4_1_H_Intranet": {
    "en": `You can easily gain access to the Singapore Police intranet. If you can solve this puzzle, I am confident that you will be able to prevent the assassination attempt against me and I will be able to sleep peacefully again.
  The URL is [b]bit.ly/pol-x-y-z[/b]
  Here x, y, z are to be arranged in the order from small to large.
  [b]Please enter x-y-z in the chat. [/b]
  ::next-1::
  [img]https://www.paragamix.com/images/Singapur/px_singapur_intranetD.jpg[/img]
  `,
    de: `Zum Intranet der Polizei Singapur kannst du dir leicht Zutritt verschaffen. Wenn du dieses Rätsel lösen kannst, bin ich zuversichtlich, dass du das Attentat gegen mich verhindern kannst und ich wieder ruhig schlafen kann. 
  Die URL lautet [b]bit.ly/polizei-x-y-z[/b]
  Dabei sind x, y, z in der Reihenfolge von klein nach groß anzuordnen. Die Kugeln können aus verschiedenen Positionen betrachtet werden.
  [b]Gib bitte x-y-z im Chat ein. [/b]
  ::next-3::
  [img]https://www.paragamix.com/images/Singapur/px_singapur_intranetD.jpg[/img]`,
    "interaction": (message) => {
      if (matchWords(message, ['lösung', 'Solución', 'Solution', 'loesung'])) return '*LD_4_1_Intranet';
      if (matchWords(message, ['ayuda', 'Hilfe', 'aide', 'help', 'Hinweis'])) return '*HD_4_1_Intranet';
      if (matchWords(message, ['http://bit.ly/polizei-6-11-13', 'bit.ly/polizei-6-11-13', '6-11-13', '9-11-13', 'polizei-6-11-13', '(6,11,13)', '(6, 11, 13)', '61113'])) return '*SD_40_1_Fingerprint';
      return '*KD_4_1_Intranet';
    }
  },
  // 82
  "*SD_4_1_E_Intranet": {
    "en": `You can easily gain access to the Singapore Police intranet. If you can solve this puzzle, I am confident that you will be able to prevent the assassination attempt against me and I will be able to sleep peacefully again.
  The URL is [b]bit.ly/pol-x-y-z[/b]
  Here x, y, z are to be arranged in the order from small to large. The balls can be viewed from different positions.
  [b]Please enter x-y-z in the chat. [/b]
  ::next-1::
  [img]https://www.paragamix.com/images/Singapur/px_singapur_intranetD.jpg[/img]
  `,
    'de': `Zum Intranet der Polizei Singapur kannst du dir leicht Zutritt verschaffen. Wenn du dieses Rätsel lösen kannst, bin ich zuversichtlich, dass du das Attentat gegen mich verhindern kannst und ich wieder ruhig schlafen kann. 
    Die URL lautet [b]bit.ly/polizei-x-y-z[/b]
    Dabei sind x, y, z in der Reihenfolge von klein nach groß anzuordnen. Die Kugeln können aus verschiedenen Positionen betrachtet werden.
    [b]Gib bitte x-y-z im Chat ein. [/b]
    ::next-3::
    [img]https://www.paragamix.com/images/Singapur/px_singapur_intranetD.jpg[/img]`,
    "interaction": (message) => {
      if (matchWords(message, ['lösung', 'Solución', 'Solution', 'loesung'])) return '*LD_4_1_Intranet';
      if (matchWords(message, ['ayuda', 'Hilfe', 'aide', 'help', 'Hinweis'])) return '*HD_4_1_Intranet';
      if (matchWords(message, ['http://bit.ly/polizei-6-11-13', '6-11-13', '(6,11,13)', '(6, 11, 13)', '6 11 13'])) return '*SD_40_1_Fingerprint';
      return '*KD_4_1_Intranet';
    }
  },
  // 83
  "*SD_40_1_Fingerprint": {
    "en": `Well done. The URL is correct and you now have access to the Singapore police intranet. [b]Now enter the URL bit.ly/pol-6-11-13 into your browser or press the button,[/b] read through the first case on the intranet and try to solve the case. Later you can also access the cases directly via #1, #2, #3 or #4.
  ::next-4::
  [b]When things get stuck: [/b]Type in RESTART. Then enter the number of the case (e.g. case 3) and you start where you left off.
  ::next-6::
  [b]Case #1:[/b]
  The perpetrator has stolen valuable jewelry from the hotel safe in room 409 of the Fullerton Hotel in Singapore. A suspect is in custody.
  ::next-3::
  [b]Which fingerprint belongs to the perpetrator?[/b]
  ::next-5::
  Read through the first case on the intranet and try to solve the case.
  [button=https://bit.ly/polizei-6-11-13]Intranet police[/button]
  `,
    de: `Gut gemacht. Die URL ist korrekt und Du hast nun Zugriff auf das Intranet der Polizei Singapur. [b]Gib nun die URL bit.ly/polizei-6-11-13 in deinen Browser ein oder drücke den Button,[/b] lies den ersten Fall im Intranet durch und versuche den Fall zu lösen. Später kannst du die Fälle über #1, #2, #3 oder #4 auch direkt aufrufen.
  ::next-4::
  [b]Wenn es mal klemmt: [/b]Mit NEUSTART startest du neu. Gib danach die Nummer des Falls ein (z.B. Fall 3) und du startest da wo du aufgehört hast.
  ::next-6::
  [b]Fall #1:[/b]
  Der Täter hat wertvollen Schmuck aus dem Hotelsafe des Zimmers 409 des Fullerton Hotels in Singapur entwendet. Ein Verdächtiger befindet sich in Untersuchungshaft.
  ::next-3::
  [b]Welcher Fingerabdruck gehört zum Täter?[/b]
  ::next-5::
  Lies den ersten Fall im Intranet durch und versuche den Fall zu lösen.
  [button=https://bit.ly/polizei-6-11-13]Intranet Polizei[/button]
  `,
    "interaction": (message) => {
      if (matchWords(message, ['lösung', 'Solución', 'Solution', 'loesung'])) return '*LD_40_1_Fingerprint';
      if (matchWords(message, ['ayuda', 'Hilfe', 'aide', 'help'])) return '*HD_40_1_Fingerprint';
      if (matchWords(message, ['K'])) return '*SD_4a_1_Telefon';
      return '*KD_40_1_Fingerprint';
    }
  },
  // 84
  "*SD_4a_1_Telefon": {
    "en": `Your conclusion is plausible.
  ::next-1::
  I try to build a profile of the perpetrator based on the circumstantial evidence.
  ::next-1::
  [img]https://www.paragamix.com/images/Singapur/px_singapur_steckbrief_1.png[/img]
  [url=https://www.paragamix.com/images/Singapur/px_singapur_steckbrief_1.png]enlarge[/url]
  ::next-3::
  Also, do you find out who the perpetrator called from the hotel room? The CID has evaluated the telephone system and has already compiled all the telephone numbers that were dialed at the hotel at the time of the crime.
  ::next-1::
  [img]https://www.paragamix.com/images/Singapur/px_singapurD_nummernE.jpg[/img]
  [url=https://www.paragamix.com/images/Singapur/px_singapurD_nummernE.jpg]enlarge[/url]
  `,
    de: `Deine Schlussfolgerung ist nachvollziehbar. 
  ::next-2::
  Ich versuche, anhand der Indizien ein Profil des Täters zu erstellen.
  ::next-1::
  [img]https://www.paragamix.com/images/Singapur/px_singapur_steckbrief_1.png[/img]
  [url=https://www.paragamix.com/images/Singapur/px_singapur_steckbrief_1.png]vergrößern[/url]
  ::next-7::
  Findest Du auch heraus, wen der Täter aus dem Hotelzimmer angerufen hat? Die Kripo hat die Telefonanlage ausgewertet und bereits alle Telefonnummern zusammengestellt, die zur Tatzeit im Hotel gewählt wurden.
  ::next-4::
  [img]https://www.paragamix.com/images/Singapur/px_singapurD_nummernG.jpg[/img]
  [url=https://www.paragamix.com/images/Singapur/px_singapurD_nummernG.jpg]vergrößern[/url]`,
    "interaction": (message) => {
      if (matchWords(message, ['lösung', 'Solución', 'Solution', 'loesung'])) return '*LD_4a_1_Telefon';
      if (matchWords(message, ['ayuda', 'Hilfe', 'aide', 'help'])) return '*HD_4a_1_Telefon';
      if (matchWords(message, ['Maire', 'Mayor', 'Alcalde', '25783', 'Bürgermeister'])) return '*SD_4b_1_Zertifikat1';
      return '*KD_4a_1_Telefon';
    }
  },
  // 85
  "*SD_4b_1_Zertifikat1": {
    "en": `[video]https://www.youtube.com/embed/YgqhEyxbvxU[/video]
  [url=https://www.youtube.com/embed/YgqhEyxbvxU]enlarge[/url]
  ::next-7::
  I wonder why the perpetrator called the mayor.
  ::next-2::
  You are making good progress. I am satisfied with your work.
  [button=interaction-*SD_5_2_Restaurant]next case[/button]
  `,
    de: `[video]https://www.youtube.com/embed/YgqhEyxbvxU[/video]
  [url=https://www.youtube.com/embed/YgqhEyxbvxU]Video[/url]
  ::next-7::
  Ich frage mich, warum der Täter den Bürgermeister angerufen hat. 
  ::next-2::
  Du machst gute Fortschritte. Ich bin zufrieden mir deiner Arbeit.
  [button=interaction-*SD_5_2_Restaurant]nächster Fall[/button]
  `,
    disableInput: true,
    "interaction": () => {
    }
  },
  // 86
  "*SD_5_2_Restaurant": {
    "en": `[b]Case #2[/b]
  The Temple Street restaurant was completely destroyed by a bomb attack. The perpetrator left traces at the scene.
  ::next-4::
  Which footprint is from the perpetrator?
  [img]https://www.paragamix.com/images/Singapur/px_singapur_schuhe.png[/img]
  `,
    de: `[b]Fall #2[/b]
  Das Restaurant in der Temple Street wurde durch einen Bombenanschlag vollständig zerstört. Der Täter hat Spuren am Tatort hinterlassen.
  ::next-4::
  Welcher Fußabdruck stammt vom Täter ?
  [img]https://www.paragamix.com/images/Singapur/px_singapur_schuhe.png[/img]`,
    "interaction": (message) => {
      if (matchWords(message, ['lösung', 'Solución', 'Solution', 'loesung'])) return '*LD_5_2_Restaurant';
      if (matchWords(message, ['ayuda', 'Hilfe', 'aide', 'help', 'Hinweis'])) return '*HD_5_2_Restaurant';
      if (matchWords(message, ['F'])) return '*SD_6a_3_Galerie';
      return '*KD_5_2_Restaurant';
    }
  },
  // 87
  "*SD_6a_3_Galerie": {
    "en": `[b]Case #3[/b]
  There was a robbery at the Singapore Art Museum. The perpetrator stole the painting "Artist and model" by Liu Kang and replaced it with a copy. Under UV light, the perpetrator's fingerprints were identified on the picture frame. A photo of the painting before the theft is shown on the police intranet. The picture copy contains numerous mistakes. How many are there?
  ::next-4::
  [iframe]<iframe src="https://www.google.com/maps/d/embed?mid=1-fMP-C-G-lCbUtStlTjoLMVV6-BFa674" width="500" height="500"></iframe>[/iframe]
  `,
    de: `[b]Fall #3[/b]
  Im Singapur Art Museum wurde eingebrochen. Der Täter hat das Bild "Artist und Model" von Liu Kang entwendet und durch eine Kopie ausgetauscht. Unter UV-Licht wurden die Fingerabdrücke des Täters am Bilderrahmen identifziert. Im Intranet der Polizei ist ein Foto des Gemäldes vor dem Diebstahl abgebildet. Die Bildkopie enthält zahlreiche Fehler. Wie viele sind es?
  ::next-4::
  [iframe]<iframe src="https://www.google.com/maps/d/embed?mid=1-fMP-C-G-lCbUtStlTjoLMVV6-BFa674" width="500" height="500"></iframe>[/iframe]`,
    "interaction": (message) => {
      if (matchWords(message, ['lösung', 'Solución', 'Solution', 'loesung'])) return '*LD_6a_3_Galerie';
      if (matchWords(message, ['ayuda', 'Hilfe', 'aide', 'help', 'Hinweis'])) return '*HD_6a_3_Galerie';
      if (matchWords(message, ['fünf', '5', 'fuenf', 'cinq', 'cinco'])) return '*SD_6_3_Kabbala';
      return '*KD_6a_3_Galerie';
    }
  },
  // 88
  "*SD_6_3_Kabbala": {
    "en": `Yes, the forgery contains 5 errors. Moreover, by chance, the UV light has revealed a previously unknown Hebrew Kabbalah in a painting from the 16th century. The director of the museum is thrilled but he is faced with a mystery. Even though it has nothing to do with the case, feel free to help him solve [url=https://parablog.wixsite.com/singapurpolice/kabbala]the mystery[/url]
  ::next-4::
  The perpetrator left traces at the museum. I think we know his name now. What is it?
  `,
    de: `Ja, die Fälschung enthält 5 Fehler. Außerdem hat das UV-Licht durch Zufall eine bisher unbekannte hebräische Kabbalah in einem Gemälde aus dem 16. Jahrhundert zum Vorschein gebracht. Der Direktor des Museums ist begeistert aber er steht vor einem Rätsel. Auch wenn es nichts mit dem Fall zu tun hat, kannst Du ihm gerne helfen,  [url=https://parablog.wixsite.com/polizeisingapur/kabbala]das Rätsel zu lösen.[/url]
  ::next-4::
  Der Täter hat Spuren im Museum hinterlassen. Ich denke wir kennen jetzt seinen Namen. Wie lautet er?`,
    "interaction": (message) => {
      if (matchWords(message, ['lösung', 'Solución', 'Solution', 'loesung'])) return '*LD_6_3_Galerie';
      if (matchWords(message, ['ayuda', 'Hilfe', 'aide', 'help', 'Hinweis'])) return '*HD_6_3_Kabbala';
      if (matchWords(message, ['Huang', 'Wang', 'Feng'])) return '*SD_7_4_Gruppe';
      return '*KD_6_3_Kabbala';
    }
  },
  // 89
  "*SD_7_4_Gruppe": {
    "en": `There are several people named Huang Wang Feng living in Singapore. The police invited everyone to a lineup, took fingerprints and footprints.
  ::next-1::
  [img]https://www.paragamix.com/images/Singapur/px_singapurD_gruppe.jpg[/img]
  [url=https://www.paragamix.com/images/Singapur/px_singapurD_gruppe.jpg]enlarge[/url]
  ::next-3::
  Which suspect should we question? A and E already have an alibi at the time of the crime.
  [button=interaction-*SD_7b_4_B_Interview]B[/button]
  [button=interaction-*SD_7b_4_C_Interview]C[/button]
  [button=interaction-*SD_7b_4_D_Interview]D[/button]
  `,
    "de": `In Singapur leben mehrere Personen mit Namen Huang Wang Feng. Die Polizei hat alle zu einer Gegenüberstellung eingeladen, Finger- und Fußabdrücke abgenommen.
    ::next-2::
    [img]https://www.paragamix.com/images/Singapur/px_singapurD_gruppe.jpg[/img]
    [url=https://www.paragamix.com/images/Singapur/px_singapurD_gruppe.jpg]vergrößern[/url]
    ::next-3::
    Welchen Tatverdächtigen sollen wir vernehmen? A und E verfügen bereits über ein Alibi zur Tatzeit. 
    [button=interaction-*SD_7b_4_B_Interview]B[/button]
    [button=interaction-*SD_7b_4_C_Interview]C[/button]
  [button=interaction-*SD_7b_4_D_Interview]D[/button]
    `,
    disableInput: true,
    "interaction": () => {

    }
  },

  // 90
  "*SD_7b_4_B_Interview": {
    en: `[b]Interrogation protocol:[/b]
    ::next-1::
    Take a seat, Abdul...
    ::next-1::
    Maybe it will turn out that you are innocent, dear Abdul.
    ::next-2::
    Commissioner, what is this all about? I don't know why I am here and what you are accusing me of.
    ::next-2::
    Where were you yesterday between 11 pm and 1 am?
    ::next-2::
    I was with friends at the Backstage Bar in China Town.
    ::next-1::
    [b]Bag contents:[/b]
    ::next-3::
    I'm not sure we can do anything with this circumstantial evidence. Press CONTINUE to interrogate more people.
    [button=interaction-*SD_7_4_Gruppe]continue[/button]`,
    de: `[b]Vernehmungsprotokoll[/b]
    ::next-1::
    Nehmen Sie Platz, Herr Feng ...
    ::next-4::
    Kommissar, um was geht es denn? Ich weiß nicht, warum ich hier bin und was Sie mir vorwerfen.
    ::next-3::
    Wenn Sie unschuldig sind, haben Sie nichts zu befürchten. Wir tun nur unsere Arbeit.
    Wo waren Sie gestern zwischen 23 Uhr und 1 Uhr morgens ?
    ::next-5::
    Ich war mit Freunden in der Backstage Bar in China Town.
    Fragen Sie den Barkeeper und meine Freunde. Er wird es Ihnen bestätigen. 
    ::next-4::
    Vielen Dank Herr Feng. Das werden wir tun. Nun zeigen Sie uns noch, was sich in Ihren Taschen befindet.
    ::next-5::
    Gern, es ist nur diese Zigarettenschachtel, mehr habe ich nicht bei mir.
    ::next-3::
    [img]https://www.paragamix.com/images/Singapur/Zigarettenschachtel_1.jpg[/img]
    ::next-4::
    Ich bin mir nicht sicher, ob wir mit diesem Indiz etwas anfangen können. Drücke auf WEITER um weitere Personen zu vernehmen.
    [button=interaction-*SD_7_4_Gruppe]weiter[/button]
    `,
    interaction: (message) => {
    }
  },
  // 91
  "*SD_7b_4_C_Interview": {
    en: `[b]Interrogation protocol:[/b]
    ::next-1::
    "Have a seat, Abdul..."
    ::next-2::
    "But I don't want to!"
    ::next-2::
    "It sounds so bad standing up!"
    Abdul Badami sits down.
    ::next-2::
    "Maybe it will turn out that you are innocent, dear Abdul."
    ::next-2::
    "Well, what do we do then?"
    ::next-2::
    "We apologize to you and release you!"
    ::next-2::
    "I should hope so!". The suspect sniffed bravely and squinted at the inspector under half-open eyes.
    ::next-2::
    "What's it all about? Maybe I can give you a hint..."
    ::next-2::
    The commissioner swayed his head sympathetically. Then he turned to Inspector: "Did you hear that? Abdul wants to know what it's all about. . . He even wants to give a tip..."
    ::next-2::
    The inspector nodded and replied in the same tone:
    ::next-1::
    "Then Mr. Badami must know more than we suspect. Chief, it really seems to be a lucky day for us today!"
    ::next-2::
    Abdul Badami raised both arms and fought back fiercely:
    ::next-1::
    "I didn't say I knew anything ... You are twisting my words ... I do not know anything . . . Nothing at all. When your weird break-in happened at the museum, I was playing skat with my friends, like from 11:00 p.m. until just after 1:00 a.m.. So it couldn't have been me."
    ::next-2::
    The commissioner and the inspector nodded to each other. They had heard enough.
    ::next-1::
    Pocket Contents:
    ::next-3::
    I'm not sure we can do anything with this circumstantial evidence. Press CONTINUE to interrogate more people.
    [button=interaction-*SD_7_4_Gruppe]continue[/button]
    `,
    de: `[b]Vernehmungsprotokoll[/b]
    ::next-3::
    Nehmen Sie Platz, Herr Feng ...
    ::next-3::
    Gerne, Kommissar, ich bin gerne bereit, Ihnen Auskunft zu geben.
    ::next-3::
    Das hört sich gut an an, dann erzählen Sie doch mal wo Sie gestern zwischen 23 Uhr und 1 Uhr morgens waren ?
    ::next-4::
    Herr Kommissar, ich habe die Geldbörse vor dem Budda-Tempel gefunden und wollte sie zurückgeben, ehrlich. Aber ich habe sie zunächst mit nach Hause genommen und wollte sie erst später zur Polizei bringen. Sie können mir das doch nicht zum Vorwurf machen?
    ::next-3::
    Was haben Sie so spät in der Nacht am Budda-Tempel verloren?
    ::next-3::
    Ich war beten, und beim Herausgehen habe ich die Geldbörse gefunden. Sie lag direkt am Eingang. Ich wollte sie zurückgeben, ehrlich.
    ::next-5::
    Vielen Dank Herr Feng. Wir werden ihre Angaben überprüfen. Nun zeigen Sie uns noch, was sich in Ihren Taschen befindet.
    ::next-3::
    Ich habe nicht viel dabei, Pfefferminzbonbons und meinen Autoschlüssel. Das können Sie gerne untersuchen.
    ::next-3::
    [img]https://www.paragamix.com/images/Singapur/px_singapurD_schluessel.jpg[/img]
    ::next-3::
    Ich bin mir nicht sicher, ob wir mit diesem Indiz etwas anfangen können. Drücke auf WEITER um weitere Personen zu vernehmen.
    [button=interaction-*SD_7_4_Gruppe]weiter[/button]
    `,
    interaction: (message) => {
    }
  },
  // 92
  "*SD_7b_4_D_Interview": {
    en: `[b]Interrogation protocol[/b]
    ::next-1::
    Take a seat, Huang
    ::next-2::
    But I don't want to!
    ::next-2::
    It sounds so bad standing up!
    Maybe you will turn out to be innocent, dear Huang.
    ::next-2::
    Well, and what do we do then?
    ::next-2::
    We apologize to you and release you!
    ::next-2::
    I hope so!
    Commissioner, what is this all about? Maybe I can give you a hint....
    ::next-2::
    Did you hear that, inspector? Huang wants to know what it's all about ... He even wants to give a tip...
    ::next-1::
    Then Mr. Feng must know more than we suspect. Boss, it really seems to be a lucky day for us today!
    ::next-1::
    I didn't say I knew anything ... You are twisting my words ... I do not know anything . . . Nothing at all. When your weird break-in happened at the museum, I was playing skat with my friends, like from 11:00 p.m. until just after 1:00 a.m.. So it could not have been me.
    ::next-2::
    Thank you, dear Huang. We have heard enough.
    Still show us what you carry in your pockets.
    ::next-4::
    It's just an old piece of paper. What do you want with it?
    ::next-1::
    [img]https://www.paragamix.com/images/Singapur/px_singapurD_chang.jpg[/img]
    ::next-5::
    [iframe]<iframe src="https://www.google.com/maps/d/embed?mid=1WfHn85X9cVJQ2OmnO5G7It9fFLffoWli" width="500" height="500"></iframe>[/iframe]
    ::next-5::
    Try to clarify what the X stands for and give me the location.
    ::next-5::
    Clarify what the X stands for and tell me the location or press CONTINUE to interrogate more people.
    [button=interaction-*SD_7_4_Gruppe]continue[/button]
    `,
    de: `[b]Vernehmungsprotokoll[/b]
    ::next-3::
    Nehmen Sie Platz, Huang. 
    ::next-3::
    Ich will aber nicht!
    ::next-3::
    Im Stehen hört es sich so schlecht zu!
    Vielleicht stellt sich heraus, dass Sie unschuldig sind, lieber Huang.
    ::next-3::
    Na, und was machen wir dann?
    ::next-4::
    Wir entschuldigen uns bei Ihnen und lassen Sie frei !
    ::next-3::
    Das will ich hoffen!
    Kommissar, um was geht es denn? Vielleicht kann ich Ihnen einen Tipp geben...
    ::next-4::
    Haben Sie das gehört, Inspektor? Huang will wissen, worum es geht ... Er will sogar einen Tipp geben...
    ::next-3::
    Dann muß Herr Feng ja mehr wissen, als wir ahnen. Chef, es scheint heute wirklich ein Glückstag für uns zu sein!
    ::next-3::
    Ich habe nicht gesagt, dass ich etwas weiß ... Sie drehen mir das Wort im Munde um ... Ich weiß gar nichts . . . Überhaupt nichts. Als Ihr komischer Einbruch im Museum geschah, spielte ich mit meinen Freunden Skat, so von 23.00 Uhr bis kurz nach 1.00 Uhr. Ich kann es also nicht gewesen sein.
    ::next-4::
    Danke, lieber Huang. Wir haben genug gehört.
    Zeig uns noch, was du in deinen Taschen mit dir trägst. 
    ::next-4::
    Das ist nur ein alter Zettel. Was wollt ihr damit?
    ::next-3::
    [img]https://www.paragamix.com/images/Singapur/px_singapurD_chang.jpg[/img]
    ::next-5::
    [iframe]<iframe src="https://www.google.com/maps/d/embed?mid=1WfHn85X9cVJQ2OmnO5G7It9fFLffoWli" width="500" height="500"></iframe>[/iframe]
    ::next-5::
    Kläre, wofür das X steht und teile mir den Ort bekannt oder drücke auf WEITER, um weitere Personen zu vernehmen.
    [button=interaction-*SD_7_4_Gruppe]weiter[/button]
    `,
    interaction: (message) => {
      if (matchWords(message, ['lösung', 'Solución', 'Solution', 'loesung'])) return '*LD_7b_4_D_Interview';
      if (matchWords(message, ['ayuda', 'Hilfe', 'aide', 'help'])) return '*HD_7b_4_D_Interview';
      if (matchWords(message, ['Chong', 'Pang', 'Yishun'])) return '*KD_7b_4_D_Interview';
      if (matchWords(message)) return '*KD_7b_4_D_Interview';
      return '*KD_7b_4_D_Interview';
    }
  },
  // 93
  "*SD_8_4_Zusatz": {
    en: `I have completed the perpetrator profile.
    ::next-1::
    [img]https://www.paragamix.com/images/Singapur/px_singapur_steckbrief_2.jpg[/img]
    ::next-1::
    The next assignment sends Huang to the Chinese Market in the north of the city, which is controlled by members of the Hong Brotherhood.
    ::next-3::
    Can you solve the puzzle?
    [button=https://www.paragamix.com/dsinga/chinamarket/app-files/index.html]Chong Pang market[/button]
    `,
    de: `Ich habe das Täterprofil ergänzt. 
    ::next-1::
    [img]https://www.paragamix.com/images/Singapur/px_singapur_steckbrief_2.jpg[/img]
    ::next-1::
    Der nächste Auftrag schickt Huang in den Chinesen Markt im Norden der Stadt, der von Mitgliedern der Hong Bruderschaft kontrolliert wird.
    ::next-3::
    Kannst du das Rätsel lösen?
    [button=https://www.paragamix.com/dsinga/chinamarket/app-files/index.html]Chong Pang Markt[/button]
    `,
    interaction: (message) => {
      if (matchWords(message, ['lösung', 'Solución', 'Solution', 'loesung'])) return '*LD_8_4_Zusatz';
      if (matchWords(message, ['ayuda', 'Hilfe', 'aide', 'help'])) return '*HD_8_4_Zusatz';
      if (matchWords(message, ['113'])) return '*SD_9_4_News';
      if (matchWords(message)) return '*KD_8_4_Zusatz';
      return '*KD_8_4_Zusatz';
    }
  },
  // 94
  "*Schritt7a #4 Taeter": {
    en: `I took care of it. We exchanged the traitor for one of the dictators on display in the museum as a deterrent. The dictator is now swimming in Marina Bay.
    ::next-5::
    [img]https://www.paragamix.com/images/Singapur/SAM_newspaperE.jpg[/img]
    [url=https://www.paragamix.com/images/Singapur/SAM_newspaperE.jpg]enlarge[/url]
    ::next-3::
    For this order you will receive another part of your certificate. We need bright minds for our secret society. Do you know the name of the communist dictator ?
    ::next-1::
    [iframe]<iframe src="https://www.google.com/maps/embed?pb=!4v1611654008933!6m8!1m7!1sul12_GeuktnKXOY7bhyM4Q!2m2!1d1.297209591208344!2d103.8510773618115!3f154.17743336277744!4f-26.442237411768446!5f0.7820865974627469" width="500" height="500" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>[/iframe]
    ::next-1::
    [img]https://www.paragamix.com/images/Singapur/schritt7a-4-taeter.png[/img]
    `,
    de: `Ich habe mich darum gekümmert. Wir haben den Verräter zur Abschreckung ausgetauscht gegen einen der Diktatoren und im Museum ausgestellt. Der Diktator schwimmt jetzt in der Marina Bay. 
    ::next-5::
    [img]https://www.paragamix.com/images/Singapur/SAM_newspaperG.jpg[/img]
    [url=https://www.paragamix.com/images/Singapur/SAM_newspaperG.jpg]vergrößern[/url]
    ::next-3::
    Für diesen Auftrag erhältst du einen weiteren Teil deines Zertifikats. Für unseren Geheimbund brauchen wir kluge Köpfe. Kennst du den Namen des kommunistischen Diktators ?
    ::next-1::
    [iframe]<iframe src="https://www.google.com/maps/embed?pb=!4v1611654008933!6m8!1m7!1sul12_GeuktnKXOY7bhyM4Q!2m2!1d1.297209591208344!2d103.8510773618115!3f154.17743336277744!4f-26.442237411768446!5f0.7820865974627469" width="500" height="500" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>[/iframe]
    ::next-1::
    [img]https://www.paragamix.com/images/Singapur/schritt7a-4-taeter.png[/img]`,
    interaction: (message) => {
      if (
        matchWords(message, [
          'lösung', 'Solución', 'Solution', 'loesung'
        ])
      )
        return `ST_8_5_Probe`;

      if (
        matchWords(message, [
          "ayuda",
          "hilfe",
          "aide",
          "help",
        ])
      )
        return `HT_7a_4_Diktator`;

      return 'KT_7a_4_Diktator';
    },
  },
  // 95
  "*SD_9_4_News": {
    en: `We are too late, the perpetrator has already struck. The police know enough and have taken the right Huang into custody.
    ::next-5::
    [img]https://www.paragamix.com/images/Singapur/SAM_newspaperE.jpg[/img]
    [url=https://www.paragamix.com/images/Singapur/SAM_newspaperE.jpg]enlarge[/url]
    ::next-2::
    [img]https://www.paragamix.com/images/Singapur/px_singapurD_chang.jpg[/img]
    ::next-2::
    Huang had one last job to complete. I can tell you what the font of the last link stands for: it stands for Kryzio Kalnas - the name of the organization I mentor. Huang apparently had plans to grace our small meeting at my residence with his visit.
    
    My friend, you have done well up to this point. Our paths now part. Thank you for your support. You helped catch my potential killer.
    
    Don't try to find out where I live, I couldn't forgive you for that. My arms are very long ...`,
    de: `Wir kommen zu spät, der Täter hat bereits zugeschlagen. Die Polizei weiß genug und hat den richtigen Huang in Untersuchungshaft genommen. 
    ::next-5::
    [img]https://www.paragamix.com/images/Singapur/SAM_newspaperG.jpg[/img]
    [url=https://www.paragamix.com/images/Singapur/SAM_newspaperG.jpg]vergrößern[/url]
    ::next-4::
    [img]https://www.paragamix.com/images/Singapur/px_singapurD_chang.jpg[/img]
    ::next-4::
    Huang hatte noch einen letzten Auftrag durchzuführen. Ich kann dir verraten, wofür die Schrift des letzten Links steht: Sie steht für Kryzio Kalnas - den Namen der Organisation, deren Mentor ich bin. Huang hatte offenbar den Plan, unsere kleine Tagung an meinem Wohnort mit seinem Besuch zu beehren. 
    ::next-2::
    Mein Freund, du hast dich wacker geschlagen bis hierher. Unsere Wege trennen sich nun. Danke für Deine Unterstützung. Du hast geholfen, meinen potentiellen Mörder dingfest zu machen. 
    ::next-3::
    Versuche nicht herauszufinden, wo ich lebe, das könnte ich dir nicht verzeihen. Meine Arme sind sehr lang ...`,
    interaction: (message) => {
      if (matchWords(message, ['lösung', 'Solución', 'Solution', 'loesung'])) return '*LD_9_4_News';
      if (matchWords(message, ['ayuda', 'Hilfe', 'aide', 'help'])) return '*HD_9_4_News';
      if (matchWords(message, ['Moulin', 'chateau', 'demoulin'])) return '*SD_11_Finale';
      if (matchWords(message)) return '*KD_9_4_News';
      return '*KD_9_4_News';
    }
  },
  // 96
  "*Schritt8 #5T Probe": {
    en: `You have passed the [b]acid test[/b]. You are worthy to participate in our initiation ceremony. Huang Wang Feng invites you [b]on behalf of the Grand Master [/b]to the Kai Xiang Tang (开 香 堂) of the Kongsi and takes your oath.
    ::next-5::
    [img]https://www.paragamix.com/images/Singapur/schmetterlingE.jpg[/img]
    [url=https://www.paragamix.com/images/Singapur/schmetterlingE.jpg]enlarge[/url]
    ::next-3::
    Choose wisely the two virtues of our brotherhood to which you take your oath.
    [button=https://goo.gl/maps/ScVSiWRL2DLMgVZw6]search easy[/button]
    [button=https://goo.gl/maps/wL2gzFbBRCNEhQzk6]hard[/button]
    `,
    de: `Du hast die [b]Bewährungsprobe[/b] bestanden. Du bist würdig, an unserer Initiationszeremonie teilzunehmen. Huang Wang Feng lädt dich [b]im Auftrag des Großmeisters [/b]zur Kai Xiang Tang (开 香 堂) des Kongsi ein und nimmt dir deinen Eid ab. 
    ::next-5::
    [img]https://www.paragamix.com/images/Singapur/schmetterlingG.jpg[/img]
    [url=https://www.paragamix.com/images/Singapur/schmetterlingG.jpg]vergrößern[/url]
    ::next-3::
    Wähle die beiden Tugenden unserer Bruderschaft, auf die du deinen Eid leistest, mit Bedacht aus.
    [button=https://goo.gl/maps/ScVSiWRL2DLMgVZw6]Suche leicht[/button]
    [button=https://goo.gl/maps/wL2gzFbBRCNEhQzk6]schwer[/button]
    `,
    interaction: (message) => {
      if (matchWords(message, ['lösung', 'Solución', 'Solution', 'loesung'])) return 'ST_9_6_Zertifikat';
      if (matchWords(message, ['ayuda', 'Hilfe', 'aide', 'help', 'Hinweis'])) return '*HT_8_5_Probe';
      if (matchWords(message, ['gehorsam', 'treue'])) return 'ST_9_6_Zertifikat';
      if (matchWords(message)) return '*KT_8_5_Probe';
    }
  },

  // 97
  "*Schritt9 #6T Zertifikat": {
    en: `The first duties of a brother are obedience to the brotherhood and loyalty to his brothers. If he is so dishonorable as to violate this law, he can drown in the ocean within a month. His flesh will float on the surface of the water and his bones will be buried in the bottom of the sea. [b]What is the 3-digit code of your certificate?[/b] The sums of each line add up to 15.
    ::next-4::
    [img]https://www.paragamix.com/images/Singapur/schritt9-6t-zertifikat.png[/img]
    ::next-2::
    [img]https://www.paragamix.com/images/Singapur/st-4b-1-zertifikat1.png[/img]
    ::next-1::
    [img]https://www.paragamix.com/images/Singapur/st-7a-4-diktator.png[/img]
    `,
    de: `Die ersten Pflichten eines Bruders sind Gehorsam gegenüber der Bruderschaft und Treue zu seinen Brüdern. Wenn er so unehrenhaft ist, dass er gegen dieses Gesetz verstößt, kann er innerhalb eines Monats im Ozean ertrinken. Sein Fleisch wird auf der Wasseroberfläche schweben und seine Knochen begraben werden im Meeresboden. [b]Wie lautet der 3stellige Code deines Zertifikats?[/b]
    ::next-4::
    [img]https://www.paragamix.com/images/Singapur/schritt9-6t-zertifikat.png[/img]
    ::next-2::
    [img]https://www.paragamix.com/images/Singapur/st-4b-1-zertifikat1.png[/img]
    ::next-1::
    [img]https://www.paragamix.com/images/Singapur/st-7a-4-diktator.png[/img]
    `,
    interaction: (message) => {
      if (
        matchWords(message, [
          'Aufloesung', '174', 'Auflösung', 'Resolución', 'resolution', 'lösung', 'loesung', '1 7 4'
        ])
      )
        return `ST_10_7_Moulin`;

      if (
        matchWords(message, [
          "ayuda",
          "hilfe",
          "aide",
          "help",
          "Hinweis"
        ])
      )
        return `HT_9_6_Zertifikat`;

      return 'KT_9_6_Zertifikat';
    },
  },

  // 98
  "*Schritt10 #7T Moulin": {
    en: `[b]Congratulations[/b] You are now a Hongmen. Cherish your membership certificate. If you are so shameless as to sell the tokens of the Hong Brotherhood, you may be killed by a tiger or bitten in the eyes by a snake.
    ::next-2::
    You now have an honorable [b]additional task[/b] as a Hongmen: find out the name of the estate of the boss of the gang that is stealing our brotherhood's business.

    ::next-2::
    Der Verräter hat vor seinem Tod noch gesungen. „Wenn der Pate Singapur besucht, treffen wir uns im Drinks Emporium. Das Regal hat 8x4 Fächer und verschlüsselt die Google Maps X-Koordinate seines Wohnorts: a8a6.369245. Die Y-Koordinate lautet 1.609512.
    [button=https://goo.gl/maps/Ki5kxdEztuaWRvjb6]Bar suchen[/button]

    ::next-1::
    Wenn du die Zusatzaufgabe nicht lösen möchtest: Wie hat dir das Spiel gefallen?
    [button=interaction-Bewertung gut]gut[/button]
    [button=interaction-Bewertung schlecht]nicht gut[/button]`,
    de: `[b]Ich gratuliere Dir.[/b] Du bist jetzt ein Hongmen. Halte dein Mitgliedszertifikat in Ehren. Wenn du so schamlos bist, die Zeichen der Hong-Bruderschaft zu verkaufen, kannst du von einem Tiger getötet oder von einer Schlange in die Augen gebissen werden.
    ::next-4::
    Du hast nun als Hongmen eine ehrenhafte [b]Zusatzaufgabe[/b]: Finde den Namen des Anwesens des Chefs der Bande heraus, die unserer Bruderschaft das Geschäft streitig macht.
    ::next-2::
    Der Verräter hat vor seinem Tod noch gesungen. „Wenn der Pate Singapur besucht, treffen wir uns im Drinks Emporium. Das Regal hat 8x4 Fächer und verschlüsselt die Google Maps X-Koordinate seines Wohnorts: a8a6.369245. Die Y-Koordinate lautet 1.609512.
    [button=https://goo.gl/maps/Ki5kxdEztuaWRvjb6]Bar suchen[/button]
    ::next-2::
    Wenn du die Zusatzaufgabe nicht lösen möchtest: Wie hat dir das Spiel gefallen?
    [button=interaction-Bewertung gut]gut[/button]
    [button=interaction-Bewertung schlecht]nicht gut[/button]
    `,
    interaction: (message) => {
      if (matchWords(message, ['lösung', 'Solución', 'Solution', 'loesung', 'Moulin', 'LeMoulin'])) return 'ST_11_8_Finale';
      if (matchWords(message, ['Hilfe', 'ayuda', 'aide', 'help'])) return 'HT_10_7_Moulin';
      if (matchWords(message)) return 'FT_9_6_Zertifikat';
    }
  },
  // 99
  "*Schritt12 Detektiv": {
    en: `Leider kannst du erst ab Februar 2021 in die Rolle des Detektivs schlüpfen.

    ::next-2::
    In this game you take on the role of the perpetrator.
    [button=interaction-ST_2_1_Hong]Hello Huang[/button]`,
    de: `Leider kannst du erst ab Februar 2021 in die Rolle des Detektivs schlüpfen. 
    ::next-1::
    In diesem Spiel nimmst du in die Rolle des Täters ein.
    [button=interaction-ST_2_1_Hong]Hallo Huang[/button]`,
    disableInput: true,
    interaction: (message) => {
      if (matchWords(message, ['lösung', 'Solución', 'Solution', 'loesung'])) return '*Schritt13';
      if (matchWords(message, ['ayuda', 'Hilfe', 'aide', 'help', 'Hinweis'])) return '*Hilfe12';
      if (matchWords(message)) return '*Klammer12';
    }
  },

  // 100
  "*SD_11_Finale": {
    en: `Thank you very much for your help.
    ::next-2::
    You have also passed this test.
    The godfather of the Kryziu Kalne Brotherhood Christian Lueder is finally tracked down in faraway France. I'll send a team there. The mission is accomplished.
    [url=https://www.paragamix.com/en-us/escape_carrie_e]You can learn more about his family here[/url].
    ::next-2::
    You can book other exciting reality escape games via [url=https://www.paragamix.com/de]www.paragamix.com[/url], for example [url=https://www.paragamix.com/en-us/escape_adele_e]Adele@HorrorCamp[/url].
    ::next-2::
    Follow us on [url=https://www.facebook.com/Paragamix/]Facebook[/url]. We regularly give away codes among all followers.
    ::next-3::
    Did you like "Secret societies Singapore"?
    [button=interaction-Bewertung gut]yes[/button]
    [button=interaction-Bewertung schlecht]no[/button]`,
    de: `Vielen Dank für deine Hilfe.
    ::next-2::
    Du hast auch diese Bewährungsprobe bestanden. 
    Der Pate der Kryziu Kalne Bruderschaft Christian Lueder ist endlich im fernen Frankreich aufgespürt. Ich schicke ein Team dort hin. Die Mission ist erfüllt. 
    [url=https://www.paragamix.com/de/escape_carrie_g]Hier kannst Du mehr über seine Familie erfahren.[/url]
    ::next-4::
    Wenn du NEUSTART eintippst und danach HALLO HUANG, kannst du die gleiche Mission aus Sicht des Täters erleben.
    ::next-3::
    Weitere spannende Reality Escape Games kannst du buchen über [url=https://www.paragamix.com/de]www.paragamix.com[/url], zum Beispiel [url=https://www.paragamix.com/de/escape_adele_g]Adele@HorrorCamp[/url].
    ::next-4::
    Folge uns auf [url=https://www.facebook.com/Paragamix/]Facebook[/url]. Wir verschenken regelmäßig Codes unter allen Followern.
    ::next-3::
    Wie hat dir "Secret Societies Singapur" gefallen?
    [button=interaction-Bewertung gut]gut[/button]
    [button=interaction-Bewertung schlecht]nicht gut[/button]
    `,
    disableInput: true,
    interaction: (message) => {
      if (matchWords(message, ['ayuda', 'Hilfe', 'aide', 'help', 'Hinweis'])) return '*HT_11_8_Finale';
      if (matchWords(message)) return '*KT_11_8_Finale';
    }
  },
  // 101
  "*Schritt13": {
    en: `Schritt13
    Wenn dir unser Reality Escape Game gefallen hat, freuen wir uns über eine [url=https://g.page/Paragamix/review?gm]Bewertung bei Google[/url]. Weitere spannende Reality Escape Games kannst du buchen über [url=https://www.paragamix.com]www.paragamix.com[/url].`,
    de: `Schritt13
    Wenn dir unser Reality Escape Game gefallen hat, freuen wir uns über eine [url=https://g.page/Paragamix/review?gm]Bewertung bei Google[/url]. Weitere spannende Reality Escape Games kannst du buchen über [url=https://www.paragamix.com]www.paragamix.com[/url].`,
    interaction: (message) => {
      if (matchWords(message, ['Hilfe', 'Hinweis', 'ayuda', 'aide', 'help'])) return '*Hilfe13';
      if (matchWords(message)) return '*Klammer13';
    }
  },
  // 102
  "*FD_1": {
    en: `Unfortunately, this is not correct. With HELP you get a hint.`,
    de: `Das ist leider nicht richtig. Mit HILFE erhältst du einen Tipp.`,
    interaction: (message) => {
      if (matchWords(message, ['lösung', 'Solución', 'Solution', 'huang', 'hallo huang'])) return 'ST_2_1_Hong';
      if (matchWords(message, ['Hilfe', 'ayuda', 'aide', 'help'])) return 'H_Schritt_1';
      if (matchWords(message, ['Christian', 'HalloChristian', 'hellochristian', 'haloChristian'])) return '*SD_4_1_Level';

    }
  },
  // 103
  "*FD_2": {
    en: `Unfortunately, this is not correct. With HELP you get a hint.`,
    de: `Das ist leider nicht richtig. Mit HILFE erhältst du einen Tipp. `,
    interaction: (message) => {
      if (matchWords(message, ["lösung", "Solución", "Solution", "Hong", 'https://tinyurl.com/…', "http://tinyurl.com/i..."])) return 'ST_3_1_Intranet';
      if (matchWords(message, ['Hilfe', 'ayuda', 'aide', 'help'])) return 'Hilfe2';

    }
  },
  // 104
  "*FD_3": {
    en: `Unfortunately, this is not correct. Your membership certificate is not complete until you have completed all orders. Please enter the number of the next order, e.g. #2 for the 2nd order. With HELP you will get a hint.`,
    de: `Das ist leider nicht richtig. Dein Mitgliedszertifikat ist erst komplett, wenn du alle Aufträge erledigt hast. Gib bitte die Nummer des nächsten Auftrags an, z.B. #2 für den 2. Auftrag. 
    Mit HILFE erhältst du einen Tipp.`,
    interaction: (message) => {
      if (matchWords(message, ['Hilfe', 'ayuda', 'aide', 'help'])) return '*Hilfe Hauptmenu';

    }
  },
  // 105
  "*FD_4_1_Intranet": {
    en: `Unfortunately, this is not correct. With HELP you get a hint.`,
    de: `Das ist leider nicht richtig. Mit HILFE erhältst du einen Tipp. `,
    interaction: (message) => {
      if (matchWords(message, ['lösung', 'Solución', 'Solution', 'loesung'])) return '*LD_4_1_Intranet';
      if (matchWords(message, ['Hilfe', 'ayuda', 'aide', 'help'])) return '*HD_4_1_Intranet';
      if (matchWords(message, ['http://bit.ly/polize...', 'bit.ly/polizei-6-11-...', 'pol-6-11-13', 'polizei-6-11-13', '6-11-13', '6,11,13', '6, 11, 13', '61113', '6 11 13'])) return '*SD_40_1_Fingerprint';
    }
  },
  // 107
  "*FD_40_1_Fingerprint": {
    en: `Unfortunately, this is not the letter for the fingerprint I am looking for. With HELP you get a hint.`,
    de: `Das ist leider nicht der Buchstabe für den Fingerabdruck, den ich suche. 
    Mit HILFE erhältst du einen Tipp. `,
    interaction: (message) => {
      if (matchWords(message, ['lösung', 'Solución', 'Solution', 'loesung'])) return '*LD_40_1_Fingerprint';
      if (matchWords(message, ['Hilfe', 'ayuda', 'aide', 'help'])) return '*HD_40_1_Fingerprint';
      if (matchWords(message, ['K'])) return '*SD_4a_1_Telefon';

    }
  },
  // 108
  "*FD_4a_1_Telefon": {
    en: `Unfortunately, this is not the name I am looking for. With HELP you get a hint.`,
    de: `Das ist leider nicht der Name, den ich suche.
    Mit HILFE erhältst du einen Tipp.`,
    interaction: (message) => {
      if (matchWords(message, ['lösung', 'Solución', 'Solution', 'loesung'])) return '*LD_4a_1_Telefon';
      if (matchWords(message, ['Hilfe', 'ayuda', 'aide', 'help'])) return '*HD_4a_1_Telefon';
      if (matchWords(message, ['Alcalde', 'Mayor', 'Maire', 'Bürgermeister', '25783'])) return '*SD_4b_1_Zertifikat1';

    }
  },
  // 109
  "*FD_5_2_Restaurant": {
    en: `Unfortunately, this is not correct. With HELP you get a hint.`,
    de: `Das ist leider nicht richtig. Mit HILFE erhältst du einen Tipp. `,
    interaction: (message) => {
      if (matchWords(message, ['lösung', 'Solución', 'Solution', 'loesung'])) return '*LD_5_2_Restaurant';
      if (matchWords(message, ['Hilfe', 'ayuda', 'aide', 'help'])) return '*HD_5_2_Restaurant';
      if (matchWords(message, ['F'])) return '*SD_6a_3_Galerie';

    }
  },
  // 110
  "*FD_6a_3_Galerie": {
    en: `Unfortunately, this is not correct. With HELP you get a hint.`,
    de: `Das ist leider nicht richtig. Mit HILFE erhältst du einen Tipp. `,
    interaction: (message) => {
      if (matchWords(message, ['lösung', 'Solución', 'Solution', 'loesung'])) return '*LD_6a_3_Galerie';
      if (matchWords(message, ['Hilfe', 'ayuda', 'aide', 'help'])) return '*HD_6a_3_Galerie';
      if (matchWords(message, ['5', 'fünf', 'fuenf', 'cinq', 'cinco'])) return '*SD_6_3_Kabbala';

    }
  },
  // 111
  "*FD_6_3_Kabbala": {
    en: `Unfortunately, this is not correct. With HELP you get a hint.`,
    de: `Das ist leider nicht richtig. Mit HILFE erhältst du einen Tipp. `,
    interaction: (message) => {
      if (matchWords(message, ['lösung', 'Solución', 'Solution', 'loesung'])) return '*LD_6_3_Galerie';
      if (matchWords(message, ['Hilfe', 'ayuda', 'aide', 'help'])) return '*HD_6_3_Kabbala';
      if (matchWords(message, ['Huang', 'Wang', 'Feng'])) return '*SD_7_4_Gruppe';

    }
  },
  // 112
  "*FD_7b_4_D_Interview": {
    en: `Unfortunately, this is not correct. With HELP you get a hint.`,
    de: `Das ist leider nicht richtig. Mit HILFE erhältst du einen Tipp. `,
    interaction: (message) => {
      if (matchWords(message, ['lösung', 'Solución', 'Solution', 'loesung'])) return '*LD_7b_4_D_Interview';
      if (matchWords(message, ['Hilfe', 'ayuda', 'aide', 'help'])) return '*HD_7b_4_D_Interview';
      if (matchWords(message, ['Yishun', 'Chong', 'Pang'])) return '*SD_8_4_Zusatz';

    }
  },
  // 113
  "*FD_8_4_Zusatz": {
    en: `Unfortunately, this is not correct. What you are looking for is a 3-digit code of the Singapore Police.`,
    de: `Das ist leider nicht richtig. Mit HILFE erhältst du einen Tipp. `,
    interaction: (message) => {
      if (matchWords(message, ['lösung', 'Solución', 'Solution', 'loesung'])) return '*LD_8_4_Zusatz';
      if (matchWords(message, ['Hilfe', 'ayuda', 'aide', 'help'])) return '*HD_8_4_Zusatz';
      if (matchWords(message, ['113'])) return '*SD_9_4_News';

    }
  },
  // 114
  "*Falsch7 #4 Taeter": {
    en: `Unfortunately, this is not correct. With HELP you get a hint.`,
    de: `Das ist leider nicht richtig. Mit HILFE erhältst du einen Tipp. `,
    interaction: (message) => {
      if (matchWords(message, ['lösung', 'Solución', 'Solution', 'loesung', 'Poh', 'Chang', 'Sheng'])) return 'ST_7a_4_Diktator';
      if (matchWords(message, ['Hilfe', 'ayuda', 'aide', 'help'])) return 'HT_7_4_Markt';

    }
  },
  // 115
  "*Falsch7a": {
    en: `Unfortunately, this is not correct. With HELP you get a hint.`,
    de: `Das ist leider nicht richtig. Mit HILFE erhältst du einen Tipp. `,
    interaction: (message) => {
      if (matchWords(message, ['lösung', 'Solución', 'Solution', 'loesung', 'FidelCastro', 'Fidel', 'Castro'])) return 'ST_8_5_Probe';
      if (matchWords(message, ['Hilfe', 'ayuda', 'aide', 'help'])) return 'HT_7a_4_Diktator';

    }
  },
  // 116
  "*Falsch8 #5T Probe": {
    en: `Unfortunately, this is not correct. With HELP you get a hint.`,
    de: `Das ist leider nicht richtig. Mit HILFE erhältst du einen Tipp. `,
    interaction: (message) => {
      if (matchWords(message, ['lösung', 'Solución', 'Solution', 'loesung'])) return 'ST_9_6_Zertifikat';
      if (matchWords(message, ['Hilfe', 'ayuda', 'aide', 'help'])) return 'HT_8_5_Probe';
      if (matchWords(message, ['gehorsam', 'treue'])) return 'ST_9_6_Zertifikat';

    }
  },
  // 117
  "*FD_9_4_News": {
    en: `Unfortunately, this is not correct. With HELP you get a hint.`,
    de: `Das ist leider nicht richtig. Mit HILFE erhältst du einen Tipp. `,
    interaction: (message) => {
      if (matchWords(message, ['lösung', 'Solución', 'Solution', 'loesung'])) return '*LD_9_4_News';
      if (matchWords(message, ['Hilfe', 'ayuda', 'aide', 'help'])) return '*HD_9_4_News';
      if (matchWords(message, ['chateau', 'moulin'])) return '*SD_11_Finale';

    }
  },
  // 118
  "*Falsch10 #7 Moulin": {
    en: `Unfortunately, this is not correct. With HELP you get a hint.`,
    de: `Das ist leider nicht richtig. Mit HILFE erhältst du einen Tipp. `,
    interaction: (message) => {
      if (matchWords(message, ['lösung', 'Solución', 'Solution', 'loesung', 'Moulin', 'LeMoulin'])) return 'ST_11_8_Finale';
      if (matchWords(message, ['Hilfe', 'ayuda', 'aide', 'help'])) return 'HT_10_7_Moulin';
      if (matchWords(message, ['chateau', 'moulin'])) return '*SD_11_Finale';

    }
  },
  // 119
  "*Falsch11 #8T Finale": {
    en: `Unfortunately, this is not correct. I need the name of the building where he is staying. With HELP you get a hint.`,
    de: `Das ist leider nicht richtig. Ich brauche den Namen des Gebäudes, in dem er sich aufhält. Mit HILFE erhältst du einen Tipp.`,
    interaction: (message) => {
      if (matchWords(message, ['Hilfe', 'ayuda', 'aide', 'help'])) return 'HT_11_8_Finale';

    }
  },
  // 120
  "*Falsch12": {
    en: `Unfortunately, this is not correct. With HELP you get a hint.`,
    de: `Das ist leider nicht richtig. Mit [b]HILFE[/b] erhältst du einen Tipp. `,
    interaction: (message) => {
      if (matchWords(message, ['lösung', 'Solución', 'Solution', 'loesung'])) return '*Schritt13';
      if (matchWords(message, ['Hilfe', 'ayuda', 'aide', 'help'])) return '*Hilfe12';

    }
  },
  // 121
  "*Falsch13": {
    en: `Unfortunately, this is not correct. With HELP you get a hint.`,
    de: `Das ist leider nicht richtig. Mit HILFE erhältst du einen Tipp. `,
    interaction: (message) => {
      if (matchWords(message, ['Hilfe', 'ayuda', 'aide', 'help'])) return 'Hilfe13';

    }
  },
  // 122
  "*HD_1": {
    en: `[b]Help: [/b]If you are a perpetrator write HELLO HUANG
if you are a detective write HELLO CHRISTIAN`,
    de: `[b]Hilfe: [/b]Wenn du Täter bist schreibe HALLO HUANG
wenn du Detektiv bist schreibe HALLO CHRISTIAN
    `,
    prewrap: true,
    interaction: (message) => {
      if (matchWords(message, ['lösung', 'Solución', 'Solution', 'loesung', 'hallo huang', 'huang'])) return 'ST_2_1_Hong';
      if (matchWords(message, ['hallochristian', 'christian', 'cristian'])) return '*SD_4_1_Level';

    }
  },
  // 123
  "*HD_2": {
    en: `[b]Help: [/b]
    The numbers 3-8-20-1 must first be translated into Chinese characters. Use the table to do this. The characters must then be put together in such a way that they result in the symbol you are looking for - the character of the Brotherhood. You can also find it in the table.
    With SOLUTION you can skip this puzzle.`,
    de: `[b]Hilfe: [/b]
    Die Zahlen 3-8-20-1 müssen zunächst in chinesische Schriftzeichen übersetzt werden. Nutze dazu die Tabelle. Die Schriftzeichen müssen dann so zusammengefügt werden, dass sie das gesuchte Symbol ergeben - das Zeichen der Bruderschaft. Dieses findest du ebenfalls in der Tabelle.  
    Mit LÖSUNG kannst du dieses Rätsel überspringen.`,
    interaction: (message) => {
      if (matchWords(message, ['lösung', 'Solución', 'Solution', 'loesung', 'Hong', 'https://tinyurl.com/intrahong', 'http://tinyurl.com/intrahong'])) return 'ST_3_1_Intranet';

    }
  },
  // 124
  "*HD_3": {
    en: `Unfortunately, this is not correct. With HELP you get a hint.`,
    de: `Keine Hilfe vorhanden.`,
    interaction: (message) => {

    }
  },
  // 125
  "*HD_4_1_Intranet": {
    en: `[b]Help: [/b]
    Why don't you spin the billiard ball with the number 9?
    The URL is [b]bit.ly/polizei-x-y-z[/b]. Where x, y, z are to be arranged in order from small to large.
    [b]Please type x-y-z in the chat.[/b]
    With SOLUTION you can skip this puzzle.`,
    de: `[b]Hilfe: [/b]
    Dreh doch mal die Billiardkugel mit der Nummer 9.
    Die URL lautet [b]bit.ly/polizei-x-y-z[/b]. Dabei sind x, y, z in der Reihenfolge von klein nach groß anzuordnen. 
    [b]Gib bitte x-y-z im Chat ein. [/b]
    Mit LÖSUNG kannst du dieses Rätsel überspringen.`,
    interaction: (message) => {
      if (matchWords(message, ['lösung', 'Solución', 'Solution', 'loesung'])) return '*LD_4_1_Intranet';
      if (matchWords(message, ['http://bit.ly/polizei-6-11-13', 'bit.ly/polizei-6-11-13', '6-11-13', '9-11-13', 'pol-6-11-13', '(6,11,13)', '(6, 11, 13)', '6 11 13'])) return '*SD_40_1_Fingerprint';
      return '*KD_4_1_Intranet';
    }
  },
  // 126
  "*HD_40_1_Fingerprint": {
    en: `[b]Help:[/b]
    According to the Singapore Police investigation report, there was a fluorescent liquid in the safe, which the perpetrator opened. Press the light switch in hotel room 409 to turn off the light.
    Take a good look around. In the dark, you will see the blue fingerprints of the perpetrator.
    The police found fingerprints of different people in the hotel room ([url=https://parablog.wixsite.com/polizeisingapur/raubdelikt-im-hotel-2]circumstantial evidence 1[/url]). When you turn the light back on, you will recognize the objects where the fingerprints are. Now you can easily find out which fingerprint belongs to the culprit.
    With SOLUTION you can skip this puzzle.`,
    de: `[b]Hilfe: [/b]
    Dreh doch mal die Billiardkugel mit der Nummer 9.
    Die URL lautet [b]bit.ly/polizei-x-y-z[/b]. Dabei sind x, y, z in der Reihenfolge von klein nach groß anzuordnen. 
    [b]Gib bitte x-y-z im Chat ein. [/b]
    Mit LÖSUNG kannst du dieses Rätsel überspringen.`,
    interaction: (message) => {
      if (matchWords(message, ['lösung', 'Solución', 'Solution', 'loesung'])) return '*LD_40_1_Fingerprint';
      if (matchWords(message, ['K'])) return '*SD_4a_1_Telefon';
      return '*KD_40_1_Fingerprint';
    }
  },
  // 127
  "*HD_4a_1_Telefon": {
    en: `[b]Help Case 1: [/b]
    Turn off the light in hotel room 409. The perpetrator has also left his fingerprints on the phone. Look at which digits the perpetrator dialed and, using the exclusion principle, dial the corresponding phone number that was dialed from the hotel during the time of the crime.
    With SOLUTION you can skip this puzzle.`,
    de: `[b]Hilfe Fall 1: [/b]
    Schalte das Licht im Hotelzimmer 409 aus. Der Täter hat auch am Telefon seine Fingerabdrücke hinterlassen. Sieh dir an, welche Ziffern der Täter gewählt hat und wähle nach dem Auschlußprinzip die entsprechende Telefonnummer, die im Tatzeitraum vom Hotel aus gewählt wurden.
    Mit LÖSUNG kannst du dieses Rätsel überspringen.`,
    interaction: (message) => {
      if (matchWords(message, ['lösung', 'Solución', 'Solution', 'loesung'])) return '*LD_4a_1_Telefon';
      if (matchWords(message, ['Alcalde', 'Mayor', 'Maire', 'Bürgermeister', '25783'])) return '*SD_4b_1_Zertifikat1';
      return '*KD_4a_1_Telefon';
    }
  },
  // 128
  "*HD_5_2_Restaurant": {
    en: `[b]Help case 2: [/b]
    In the investigation report for case 2, a virtual walk-through of the crime scene is possible. In the photo you will find a footprint in the dust. Compare with the photo of the footprints and try to identify which print it is.
    With SOLUTION you can skip this puzzle.`,
    de: `[b]Hilfe Fall 2: [/b]
    Im Ermittlungsbericht zu Fall 2 ist eine virtuelle Begehung des Tatorts möglich. Auf dem Foto findest du im Staub einen Fußabdruck. Vergleiche mit dem Foto der Fußabdrücke und versuche zu erkennen, um welchen Abdruck es sich handelt. 
    Mit LÖSUNG kannst du dieses Rätsel überspringen.`,
    interaction: (message) => {
      if (matchWords(message, ['lösung', 'Solución', 'Solution', 'loesung'])) return '*LD_5_2_Restaurant';
      if (matchWords(message, ['F'])) return '*SD_6a_3_Galerie';
      return '*KD_5_2_Restaurant';
    }
  },
  // 129
  "*HD_6a_3_Galerie": {
    en: `[b]Help: [/b]
    On the police intranet, you will find a picture of the crime scene before the crime in case 3. Compare the image with the image in the virtual crime scene. How many differences do you notice?
    With SOLUTION you can skip this puzzle.`,
    de: `[b]Hilfe: [/b]
    Im Intranet der Polizei findest du bei Fall 3 eine Aufnahme des Tatorts vor der Tat. Vergleiche das Bild mit der Darstellung in der virtuellen Begehung des Tatorts. Wie viele Unterschiede fallen dir auf?
    Mit LÖSUNG kannst du dieses Rätsel überspringen.`,
    interaction: (message) => {
      if (matchWords(message, ['lösung', 'Solución', 'Solution', 'loesung'])) return '*LD_6a_3_Galerie';
      if (matchWords(message, ['5', 'fünf', 'fuenf', 'cinq', 'cinco'])) return '*SD_6_3_Kabbala';

    }
  },
  // 130
  "*HD_6_3_Kabbala": {
    en: `[b]Help Case 3: [/b]
    Look around the museum. You will find a receipt from the Yum Cha restaurant, which the perpetrator seems to have lost. On the receipt you will find two names: The name of the cashier and the name of the guest.
    With SOLUTION you can skip this puzzle.`,
    de: `[b]Hilfe Fall 3: [/b]
    Sieh dich im Museum um. Du wirst einen Kassenzettel des Restaurants Yum Cha finden, den der Täter offenbar verloren hat. Auf dem Zettel wirst du zwei Namen finden: Den Name des Kassierers und den Name des Gastes.
    Mit LÖSUNG kannst du dieses Rätsel überspringen.`,
    interaction: (message) => {
      if (matchWords(message, ['lösung', 'Solución', 'Solution', 'loesung'])) return '*LD_6_3_Galerie';
      if (matchWords(message, ['Huang', 'Wang', 'Feng'])) return '*SD_7_4_Gruppe';
      return '*KD_6_3_Kabbala';
    }
  },
  // 131
  "*HD_7b_4_D_Interview": {
    en: `[b]Help: [/b]
    The X marks a specific location on the Singapore map. Orientate yourself best at the island "Seletar Island". You can find it on both maps. Now search for the name of the place, it is marked on the Singapore map.
    With SOLUTION you can skip this puzzle.`,
    de: `[b]Hilfe: [/b]
    Das X markiert eine bestimmte Stelle auf der Singapur Karte. Orientiere dich am besten an der Insel "Seletar Island". Diese findest Du auf auf beiden Karten. Suche nun den Namen des Ortes, er ist auf der Singapur Karte markiert.
    Mit LÖSUNG kannst du dieses Rätsel überspringen.`,
    interaction: (message) => {
      if (matchWords(message, ['lösung', 'Solución', 'Solution', 'loesung'])) return '*LD_7b_4_D_Interview';
      if (matchWords(message, ['Chong', 'Pang', 'Yishun'])) return '*SD_8_4_Zusatz';
      return '*KD_7b_4_D_Interview';
    }
  },
  // 132
  "*HD_8_4_Zusatz": {
    en: `[b]Help: [/b]
    Follow the arrows to the end. There you will find a puzzle. The left symbol is composed of the two right symbols.
    With SOLUTION you can skip this puzzle.`,
    de: `[b]Hilfe: [/b]
    Folge den Pfeilen bis zum Ende. Dort findest du ein Rätsel. Das linke Symbol setzt sich jeweils aus den beiden rechten Symbolen zusammen.
    Mit LÖSUNG kannst du dieses Rätsel überspringen.`,
    interaction: (message) => {
      if (matchWords(message, ['lösung', 'Solución', 'Solution', 'loesung'])) return '*LD_8_4_Zusatz';
      if (matchWords(message, ['113'])) return '*SD_9_4_News';
      return '*KD_8_4_Zusatz';
    }
  },
  // 133
  "*Hilfe7 #4 Taeter": {
    en: `[b]Help: [/b]
    There is no help for this puzzle.
    With SOLUTION you can skip this puzzle.`,
    de: `[b]Hilfe: [/b]
    Für dieses Rätsel gibt es keine Hilfe. 
    Mit LÖSUNG kannst du dieses Rätsel überspringen.`,
    interaction: (message) => {
      if (matchWords(message, ['lösung', 'Solución', 'Solution', 'loesung', 'Poh', 'Chang', 'Sheng'])) return 'ST_7a_4_Diktator';

    }
  },
  // 134
  "*Hilfe8 #5T Probe": {
    en: `[b]Help: [/b]
    There is no help for this puzzle.
    With SOLUTION you can skip this puzzle.`,
    de: `[b]Hilfe: [/b]
    Für dieses Rätsel gibt es keine Hilfe. 
    Mit LÖSUNG kannst du dieses Rätsel überspringen.`,
    interaction: (message) => {
      if (matchWords(message, ['lösung', 'Solución', 'Solution', 'loesung'])) return 'ST_9_6_Zertifikat';
      if (matchWords(message, ['gehorsam', 'treue'])) return 'ST_9_6_Zertifikat';
    }
  },
  // 135
  "*HD_9_4_News": {
    en: `[b]Help:[/b]
    1. Look around the room carefully. Press the arrow to start the beamer.
    2. On the screen you will see a Bitcoin, a hemp leaf, and a dollar sign.
    3. In the room you will find a picture with dollars. Count the value of the dollars. On the canvas, follow the path from the dollars to the corresponding letter.
    4. In the room you will find a hemp plant. Count the leaves. On the canvas, follow the path from the hemp leaf to the corresponding letter.
    5. In the room you will find a stack of BitCoin coins. Count the coins. On the canvas, follow the path from the bitcoins to the corresponding letter.
    6. Put A, B, C into the formula on the FlipChart and type the URL into your web browser.
    7. What is the name of the bitcoin?
    ::next-1::
    [button=interaction-*LD_9_4_News]skip this puzzle[/button]
    [button=interaction-*SD_11_Finale]Moulin, chateau, demoulin[/button]
    `,
    de: `[b]Hilfe:[/b]
    1. Sieh dich genau im Raum um. Drücke den Pfeil, um den Beamer zu starten. 
    2. Auf der Leinwand siehst Du einen Bitcoin, ein Hanfblatt und ein Dollar-Zeichen.
    3. Im Raum findest Du ein Bild mit Dollars. Zähle den Wert der Dollars zusammen. Folge auf dem Leinwand dem Pfad von den Dollars zum entsprechenden Buchstaben.
    4. Im Raum findest Du eine Hanfpflanze. Zähle die Blätter. Folge auf dem Leinwand dem Pfad von dem Hanfblatt zum entsprechenden Buchstaben.
    5. Im Raum findest Du einen Stapel BitCoin Münzen. Zähle die Münzen. Folge auf dem Leinwand dem Pfad von den Bitcoins zum entsprechenden Buchstaben.
    6. Setze A,B,C in die Formel auf dem FlipChart ein und gib die URL in deinen Webbrowser ein.
    7. Wie lautet der Name des Gebäudes?`,
    interaction: (message) => {
      if (matchWords(message, ['lösung', 'Solución', 'Solution', 'loesung'])) return '*LD_9_4_News';
      if (matchWords(message, ['Moulin', 'chateau'])) return '*SD_11_Finale';
      return '*KD_9_4_News';
    }
  },
  // 136
  "*Hilfe10 #7 Moulin": {
    en: `[b]Hilfe[/b]`,
    de: `[b]Hilfe[/b]
    `,
    interaction: (message) => {
      if (matchWords(message, ['lösung', 'Solución', 'Solution', 'loesung', 'Moulin', 'LeMoulin'])) return 'ST_11_8_Finale';

    }
  },
  // 137
  "*Hilfe11 #8T Finale": {
    en: `[b]Hilfe[/b]`,
    de: `[b]Hilfe[/b]
    `,
    interaction: (message) => {
    }
  },
  // 138
  "*Hilfe12": {
    en: `Hilfe12`,
    de: `Hilfe12`,
    interaction: (message) => {
      if (matchWords(message, ['lösung', 'Solución', 'Solution', 'loesung'])) return 'Schritt13';

    }
  },
  // 139
  "*Hilfe13": {
    en: `Hilfe13`,
    de: `Hilfe13`,
    interaction: (message) => {
    }
  },
  // 140
  "*Hilfe Hauptmenu": {
    en: `[b]Help:[/b]
    You must first complete all four orders. When you have collected all 3 parts of the certificate look at the table of Chinese characters on the Hong intranet and replace the characters in the middle of the member certificate with the corresponding numbers. All numbers in a row can be added to 15. The digits marked with ? make up the solution word.
    Now enter the number of the next order, e.g. #1
    With RESOLUTION you solve the whole mission and end the game.
    ::next-1::
    [button=interaction-ST_10_7_Moulin]correct solution or 174[/button]
    `,
    de: `[b]Hilfe:[/b]
    Du musst zunächst alle vier Aufträge erledigen. Wenn du alle 3 Teile des Zertifikats gesammelt hast sieh dir die Tabelle mit chinesischen Schriftzeichen im Hong Intranet an und ersetze die Schriftzeichen in der Mitte des Mitglied-Zertifikates durch die entsprechenden Ziffern. Alle Zahlen einer Reihe lassen sich zu 15 ergänzen. Die mit ? gekennzeichneten Ziffern ergeben das Lösungswort.
    Gib jetzt die Nummer des nächsten Auftrags ein, z.B. #1
    Mit AUFLOESUNG löst du die gesamte Mission auf und beendest das Spiel.`,
    interaction: (message) => {
      if (matchWords(message, ['174', 'Auflösung', 'Aufloesung', 'resolution', 'résolution', 'resolución', '1 7 4'])) return 'ST_10_7_Moulin';
    }
  },
  // 141
  "*KD_1": {
    en: `To whom is your greeting directed?
    `,
    de: `An wen richtet sich deine Begrüßung?`,
    interaction: (message) => {
      if (matchWords(message, ['lösung', 'loesung', 'Solución', 'Solution', 'holahuang', 'hellohuang', 'huang'])) return 'ST_2_1_Hong';
      if (matchWords(message, ['Hilfe', 'ayuda', 'aide', 'help'])) return 'H_Schritt_1';
      if (matchWords(message, ['christian', 'hallochristian', 'cristian', 'holachristian', 'hellochristian'])) return '*SD_4_1_Level';
    }
  },
  // 142
  "*KD_2": {
    en: `If that's your answer, I'm afraid it's wrong.
    `,
    de: `Falls das deine Antwort ist, ist sie leider falsch.`,
    interaction: (message) => {
      if (matchWords(message, ['lösung', 'Solución', 'Solution', 'loesung', 'Hong', 'https://tinyurl.com/intrahong', 'http://tinyurl.com/intrahong'])) return 'ST_3_1_Intranet';
      if (matchWords(message, ['Hilfe', 'ayuda', 'aide', 'help'])) return 'Hilfe2';
    }
  },
  // 143
  "*KD_3": {
    en: `If that is your answer, unfortunately it is wrong. Type the number of the job, e.g. job #1.
    `,
    de: `Falls das deine Antwort ist, ist sie leider falsch. Tippe die Nummer des Jobs ein, z.B. Job #1.`,
    interaction: (message) => {
      if (matchWords(message, ['Hilfe', 'ayuda', 'aide', 'help'])) return 'ST_4_1_409';
    }
  },
  // 144
  "*KD_4_1_Intranet": {
    en: `If that's your answer, I'm afraid it's wrong.
    `,
    de: `Wenn das deine Antwort ist, ist sie leider falsch.`,
    interaction: (message) => {
      if (matchWords(message, ['lösung', 'Solución', 'Solution', 'loesung'])) return '*LD_4_1_Intranet';
      if (matchWords(message, ['ayuda', 'Hilfe', 'aide', 'help'])) return '*HD_4_1_Intranet';
      if (matchWords(message, ['http://bit.ly/polizei-6-11-13', 'bit.ly/polizei-6-11-13', '6-11-13', '9-11-13', 'polizei-6-11-13', '(6,11,13)', '61113'])) return '*SD_40_1_Fingerprint';
    }
  },
  // 145
  "*KD_40_1_Fingerprint": {
    en: `Unfortunately, this is not the number for the fingerprint you are looking for.
    `,
    de: `Das ist leider nicht die Nummer für den gesuchten Fingerabruck.`,
    interaction: (message) => {
      if (matchWords(message, ['lösung', 'Solución', 'Solution', 'loesung'])) return '*LD_40_1_Fingerprint';
      if (matchWords(message, ['ayuda', 'Hilfe', 'aide', 'help'])) return '*HD_40_1_Fingerprint';
      if (matchWords(message, ['K'])) return '*SD_4a_1_Telefon';
    }
  },
  // 146
  "*KD_4a_1_Telefon": {
    en: `This person was not called by the perpetrator. Please check if the phone number is correct.
    `,
    de: `Diese Person wurde vom Täter nicht angerufen. Überprüfe bitte, ob die Telefonnummer stimmt.`,
    interaction: (message) => {
      if (matchWords(message, ['lösung', 'Solución', 'Solution', 'loesung'])) return '*LD_4a_1_Telefon';
      if (matchWords(message, ['ayuda', 'Hilfe', 'aide', 'help'])) return '*HD_4a_1_Telefon';
      if (matchWords(message, ['Alcalde', 'Mayor', 'Maire', 'Bürgermeister', '25783'])) return '*SD_4b_1_Zertifikat1';
    }
  },
  // 147
  "*KD_5_2_Restaurant": {
    en: `If that's your answer, I'm afraid it's wrong.
    `,
    de: `Wenn das deine Antwort ist, ist sie leider falsch.`,
    interaction: (message) => {
      if (matchWords(message, ['lösung', 'Solución', 'Solution', 'loesung'])) return '*LD_5_2_Restaurant';
      if (matchWords(message, ['ayuda', 'Hilfe', 'aide', 'help'])) return '*HD_5_2_Restaurant';
      if (matchWords(message, ['F'])) return '*SD_6a_3_Galerie';
    }
  },
  // 148
  "*KD_6a_3_Galerie": {
    en: `If that's your answer, I'm afraid it's wrong.`,
    de: `Wenn das deine Antwort ist, ist sie leider falsch.`,
    interaction: (message) => {
      if (matchWords(message, ['lösung', 'Solución', 'Solution', 'loesung'])) return '*LD_6a_3_Galerie';
      if (matchWords(message, ['ayuda', 'Hilfe', 'aide', 'help'])) return '*HD_6a_3_Galerie';
      if (matchWords(message, ['5', 'fünf', 'fuenf', 'cinq', 'cinco'])) return '*SD_6_3_Kabbala';
    }
  },
  // 149
  "*KD_6_3_Kabbala": {
    en: `If that's your answer, I'm afraid it's wrong.`,
    de: `Wenn das deine Antwort ist, ist sie leider falsch.`,
    interaction: (message) => {
      if (matchWords(message, ['lösung', 'Solución', 'Solution', 'loesung'])) return '*LD_6_3_Galerie';
      if (matchWords(message, ['ayuda', 'Hilfe', 'aide', 'help'])) return '*HD_6_3_Kabbala';
      if (matchWords(message, ['Huang', 'Wang', 'Feng'])) return '*SD_7_4_Gruppe';
    },
  },
  // 150
  "*KD_7b_4_D_Interview": {
    en: `This is not the place I am looking for. With HELP you get a hint.`,
    de: `Das ist nicht der Ort, den ich suche. Mit HILFE erhältst du einen Tipp.`,
    interaction: (message) => {
      if (matchWords(message, ['lösung', 'Solución', 'Solution', 'loesung'])) return '*LD_7b_4_D_Interview';
      if (matchWords(message, ['ayuda', 'Hilfe', 'aide', 'help'])) return '*HD_7b_4_D_Interview';
      if (matchWords(message, ['Chong', 'Pang', 'Yishun'])) return '*SD_8_4_Zusatz';
    }
  },
  // 151
  "*KD_8_4_Zusatz": {
    en: `If that's your answer, I'm afraid it's wrong.`,
    de: `Wenn das deine Antwort ist, dann ist sie leider falsch. `,
    interaction: (message) => {
      if (matchWords(message, ['lösung', 'Solución', 'Solution', 'loesung'])) return '*LD_7b_4_D_Interview';
      if (matchWords(message, ['ayuda', 'Hilfe', 'aide', 'help'])) return '*HD_8_4_Zusatz';
      if (matchWords(message, ['113'])) return '*SD_8_4_Zusatz';
    }
  },
  // 152
  "*Klammer7 #4 Taeter": {
    en: `If that's your answer, I'm afraid it's wrong.`,
    de: `Wenn das deine Antwort ist, dann ist sie leider falsch. `,
    interaction: (message) => {
      if (matchWords(message, ['lösung', 'Solución', 'Solution', 'loesung', 'Sheng', 'Chang', 'Poh'])) return 'ST_7a_4_Diktator';
      if (matchWords(message, ['ayuda', 'Hilfe', 'aide', 'help'])) return 'HT_7_4_Markt';
    }
  },
  // 153
  "*Klammer8 #5T Probe": {
    en: `If that's your answer, I'm afraid it's wrong.`,
    de: `Wenn das deine Antwort ist, dann ist sie leider falsch. `,
    interaction: (message) => {
      if (matchWords(message, ['lösung', 'Solución', 'Solution', 'loesung'])) return 'ST_9_6_Zertifikat';
      if (matchWords(message, ['ayuda', 'Hilfe', 'aide', 'help'])) return 'HT_8_5_Probe';
      if (matchWords(message, ['gehorsam', 'treue'])) return 'ST_9_6_Zertifikat';
    }
  },
  // 154
  "*KD_9_4_News": {
    en: `If that's your answer, I'm afraid it's wrong.`,
    de: `Wenn das deine Antwort ist, dann ist sie leider falsch. `,
    interaction: (message) => {
      if (matchWords(message, ['lösung', 'Solución', 'Solution', 'loesung'])) return '*LD_9_4_News';
      if (matchWords(message, ['ayuda', 'Hilfe', 'aide', 'help'])) return '*HD_9_4_News';
      if (matchWords(message, ['Moulin', 'chateau', 'demoulin'])) return '*SD_11_Finale';
    }
  },
  // 155
  "*Klammer10 #7 Moulin": {
    en: `If that's your answer, I'm afraid it's wrong.`,
    de: `Wenn das deine Antwort ist, dann ist sie leider falsch. `,
    interaction: (message) => {
      if (matchWords(message, ['lösung', 'Solución', 'Solution', 'loesung'])) return 'ST_11_8_Finale';
      if (matchWords(message, ['ayuda', 'Hilfe', 'aide', 'help'])) return 'HT_10_7_Moulin';
    }
  },
  // 156
  "*Klammer11 #8T Finale": {
    en: `If that's your answer, I'm afraid it's wrong.`,
    de: `Wenn das Ihre Antwort ist, fürchte ich, dass sie falsch ist.`,
    interaction: (message) => {
      if (matchWords(message, ['ayuda', 'Hilfe', 'aide', 'help'])) return 'HT_11_8_Finale';
    }
  },
  // 157
  "*Klammer12": {
    en: `If that's your answer, I'm afraid it's wrong.`,
    de: `Wenn das deine Antwort ist, dann ist sie leider falsch. `,
    interaction: (message) => {
      if (matchWords(message, ['lösung', 'Solución', 'Solution', 'loesung'])) return 'Schritt13';
      if (matchWords(message, ['ayuda', 'Hilfe', 'aide', 'help'])) return 'Hilfe12';
      if (matchWords(message, ['Moulin', 'chateau', 'demoulin'])) return '*SD_11_Finale';
    }
  },
  // 158
  "*Klammer13": {
    en: `If that's your answer, I'm afraid it's wrong.`,
    de: `Wenn das deine Antwort ist, dann ist sie leider falsch. `,
    interaction: (message) => {
      if (matchWords(message, ['ayuda', 'Hilfe', 'aide', 'help'])) return 'Hilfe13';
    }
  },
  // 159
  "*LD_4_1_Intranet": {
    en: `[b]Solution:[/b]
    If you turn the ball with the 9, you get a 6, then the puzzle is easy to solve.
    The URL is [b]bit.ly/pol-x-y-z[/b]. Here x, y, z are to be arranged in the order from small to large.
    [b]Please enter x-y-z in the chat.[/b]
    ::next-3::
    Solution: 6-11-13
    [button=interaction-*SD_40_1_Fingerprint]next[/button]
    `,
    de: `[b]Lösung:[/b]
    Wenn du die Kugel mit der 9 drehst, erhältst du eine 6, dann ist das Rätsel leicht lösbar.
    Die URL lautet [b]bit.ly/polizei-x-y-z[/b]. Dabei sind x, y, z in der Reihenfolge von klein nach groß anzuordnen. 
    [b]Gib bitte x-y-z im Chat ein. [/b]
    ::next-2::
    Lösung: 6-11-13
    [button=interaction-*SD_40_1_Fingerprint]weiter[/button]
    `,
    disableInput: true,
    interaction: (message) => {
    }
  },
  // 160
  "*LD_40_1_Fingerprint": {
    en: `[b]Solution Case 1:[/b]
    There was a fluorescent liquid in the safe, according to the investigation report on the Singapore Police intranet, which the perpetrator opened. Press the light switch in the hotel room (next to the door) to turn off the light. Take a good look around. In the dark, you will see the perpetrator's blue fingerprints. The police found fingerprints of different people in the hotel room ([url=https://parablog.wixsite.com/singapurpolice/raubdelikt-im-hotel-2]circumstantial evidence 1[/url]). If you turn the light back on, you will recognize the objects where the fingerprints are: Vase with matches, red vase, telephone, wine glass. Now you can easily find out which fingerprint belongs to the culprit.
    ::next-3::
    Solution: K
    [button=interaction-*SD_4a_1_Telefon]next[/button]
    `,
    de: `[b]Lösung Fall 1:[/b]
    Im Tresor befand sich gemäß Ermittlungsbericht im Intranet der Singapur Police eine fluoreszierende Flüssigkeit, die der Täter geöffnet hat. Drücke den Lichtschalter im Hotelzimmer (neben der Tür), um das Licht auszuschalten. Sieh dich genau um. Im Dunkeln wirst du die blauen Fingerabdrücke des Täters erkennen. Die Polizei hat im Hotelzimmer Fingerabdrücke von verschiedenen Personen gefunden ([url=https://parablog.wixsite.com/polizeisingapur/raubdelikt-im-hotel-2]Indiz 1[/url]). Wenn du das Licht wieder anstellst, wirst du die Gegenstände erkennen, an denen sich die Fingerabdrücke befinden: Vase mit Streichhölzern, rote Vase, Telefon, Weinglas.Jetzt findest du leicht heraus, welcher Fingerabdruck zum Täter gehört.
    ::next-3::
    Lösung: K
    [button=interaction-*SD_4a_1_Telefon]weiter[/button]
    `,
    disableInput: true,
    interaction: (message) => {
    }
  },
  // 161
  "*LD_4a_1_Telefon": {
    en: `[b]Solution Case 1:[/b]
    Turn off the lights in the hotel room. The perpetrator also left his fingerprints on the phone. Apparently he chose the numbers 2,3,5,7,8. Of the telephone numbers dialed from the hotel during the crime period, only the mayor's number (25783) comes into consideration.
    ::next-3::
    Solution: Mayor
    [button=interaction-*SD_4b_1_Zertifikat1]next[/button]
    `,
    de: `[b]Lösung Fall 1:[/b]
    Schalte das Licht im Hotelzimmer aus. Der Täter hat auch am Telefon seine Fingerabdrücke hinterlassen. Offenbar hat er die Ziffern 2,3,5,7,8 gewählt. Von den Telefonnummern, die im Tatzeitraum vom Hotel aus gewählt wurden, kommt nur die Nummer des Bürgermeisters (25783) in Betracht.
    ::next-3::
    Lösung: Bürgermeister
    [button=interaction-*SD_4b_1_Zertifikat1]weiter[/button]
    `,
    disableInput: true,
    interaction: (message) => {
    }
  },
  // 162
  "*LD_5_2_Restaurant": {
    en: `[b]Solution case 2:[/b]
    In the investigation report for case 2, a virtual walk-through of the crime scene is possible. In the photo you will find a footprint in the dust. Compare with the photo of the footprints and try to identify which print it is.
    ::next-3::
    Solution: F
    [button=interaction-*SD_6a_3_Galerie]next[/button]
    `,
    de: `[b]Lösung Fall 2:[/b]
    Im Ermittlungsbericht zu Fall 2 ist eine virtuelle Begehung des Tatorts möglich. Auf dem Foto findest du im Staub einen Fußabdruck. Vergleiche mit dem Foto der Fußabdrücke und versuche zu erkennen, um welchen Abdruck es sich handelt. 
    ::next-3::
    Lösung: F
    [button=interaction-*SD_6a_3_Galerie]weiter[/button]
    `,
    disableInput: true,
    interaction: (message) => {
    }
  },
  // 163
  "*LD_6a_3_Galerie": {
    en: `[b]Solution Case 3:[/b]
    Look around the museum. The picture where the fingerprints can be found has been replaced by the perpetrator. The copy contains numerous mistakes. On the police intranet, you will find a picture of the crime scene before the crime in case 3. Compare the picture with the representation in the virtual crime scene. How many differences do you notice?
    ::next-3::
    Solution: 5
    [button=interaction-*SD_6_3_Kabbala]next[/button]
    `,
    de: `[b]Lösung Fall 3:[/b]
    Sieh dich im Museum um. Das Bild, an dem die Fingerabdrücke zu finden sind, wurde vom Täter ausgetauscht. Die Kopie enthält zahlreiche Fehler. Im Intranet der Polizei findest du bei Fall 3 eine Aufnahme des Tatorts vor der Tat. Vergleiche das Bild mit der Darstellung in der virtuellen Begehung des Tatorts. Wie viele Unterschiede fallen dir auf? 
    ::next-3::
    Lösung: 5
    [button=interaction-*SD_6_3_Kabbala]weiter[/button]
    `,
    disableInput: true,
    interaction: (message) => {
    }
  },
  // 164
  "*LD_6_3_Galerie": {
    en: `[b]Solution Case 3:[/b]
    Look around the museum. You will find a receipt from the Yum Cha restaurant, which the perpetrator seems to have lost. On the receipt you will find two names: The name of the cashier and the name of the guest.
    ::next-3::
    Solution: Huang Wang Feng
    [button=interaction-*SD_7_4_Gruppe]next[/button]
    `,
    de: `[b]Lösung Fall 3:[/b]
    Sieh dich im Museum um. Du wirst einen Kassenzettel des Restaurants Yum Cha finden, den der Täter offenbar verloren hat. Auf dem Zettel wirst du zwei Namen finden: Den Name des Kassierers und den Name des Gasts.
    ::next-3::
    Lösung: Huang Wang Feng
     [button=interaction-*SD_7_4_Gruppe]weiter[/button]
    `,
    disableInput: true,
    interaction: (message) => {
    }
  },
  // 165
  "*LD_7b_4_D_Interview": {
    en: `[b]Solution:[/b]
    The X marks a specific location on the Singapore map. Orientate yourself best at the island "Seletar Island". You can find it on both maps. Now look for the name of the market in the immediate vicinity of the island, it is marked on the Singapore map.
    ::next-2::
    Solution: Yishun Chong Pang
    [button=interaction-*SD_8_4_Zusatz]next[/button]
    `,
    de: `[b]Lösung:[/b]
    Das X markiert eine bestimmte Stelle auf der Singapur Karte. Orientiere dich am besten an der Insel "Seletar Island". Diese findest Du auf auf beiden Karten. Suche nun den Namen des Marktes in unmittelbarer Nähe der Insel, er ist auf der Singapur Karte markiert. 
    ::next-2::
    Solution: Yishun Chong Pang
    [button=interaction-*SD_8_4_Zusatz]weiter[/button]`,
    disableInput: true,
    interaction: (message) => {
    }
  },
  // 166
  "*LD_8_4_Zusatz": {
    en: `[b]Solution:[/b]
    Follow the arrows to the end. There you will find a puzzle. The left symbol is composed of the two right symbols.
    ::next-2::
    Solution: 113
    [button=interaction-*SD_9_4_News]next[/button]
    `,
    de: `[b]Lösung:[/b]
    Folge den Pfeilen bis zum Ende. Dort findest du ein Rätsel. Das linke Symbol setzt sich jeweils aus den beiden rechten Symbolen zusammen.
    ::next-2::
    Lösung: 113
    [button=interaction-*SD_9_4_News]weiter[/button]
    `,
    disableInput: true,
    interaction: (message) => {
    }
  },
  // 167
  "*LD_9_4_News": {
    en: `[b]Solution:[/b]
    1. Look around the room carefully. Press the arrow to start the projector.
    On the screen you will see a Bitcoin, a hemp leaf and a dollar sign. 3.
    In the room you will find a picture with dollar bills. Count the value of the dollars together (=6). On the canvas, follow the path from the dollars to the corresponding letter (=C).
    In the room you find a hemp plant. Count the leaves (=3). Follow the path on the canvas from the hemp leaf to the corresponding letter (=A).
    5. in the room you will find a stack of bitcoin coins. Count the coins (=16). On the canvas, follow the path from the bitcoins to the corresponding letter (=B). 6.
    Put A,B,C into the formula on the FlipChart (+16-6+3) and type the URL into your web browser: bit.ly/333315
    7. what is the name of the building?
    ::next-2::
    Solution: Chateau le Moulin
    [button=interaction-*SD_11_Finale]next[/button]
    `,
    de: `[b]Lösung:[/b]
    1. Sieh dich genau im Raum um. Drücke den Pfeil, um den Beamer zu starten. 
    2. Auf der Leinwand siehst Du einen Bitcoin, ein Hanfblatt und ein Dollar-Zeichen.
    3. Im Raum findest Du ein Bild mit Dollar-Noten. Zähle den Wert der Dollars zusammen (=6). Folge auf der Leinwand dem Pfad von den Dollars zum entsprechenden Buchstaben (=C).
    4. Im Raum findest Du eine Hanfpflanze. Zähle die Blätter (=3). Folge auf der Leinwand dem Pfad von dem Hanfblatt zum entsprechenden Buchstaben (=A)
    5. Im Raum findest Du einen Stapel Bitcoin Münzen. Zähle die Münzen (=16). Folge auf der Leinwand dem Pfad von den Bitcoins zum entsprechenden Buchstaben (=B).
    6. Setze A,B,C in die Formel auf dem FlipChart ein (+16-6+3) und gib die URL in deinen Webbrowser ein: bit.ly/33333315
    7. Wie lautet der Name des Gebäudes?
    ::next-2::
    Lösung: Chateau le Moulin
    [button=interaction-*SD_11_Finale]weiter[/button]
    `,
    disableInput: true,
    interaction: (message) => {
    }
  },
};

export const globalInteractions = {
  "#1": "ST_4_1_409",
  "# 1": "ST_4_1_409",
  "#2": "ST_5_2_Galerie",
  "# 2": "ST_5_2_Galerie",
  "#3": "ST_6_3_Restaurant",
  "# 3": "ST_6_3_Restaurant",
  "#4": "ST_7_4_Markt",
  "# 4": "ST_7_4_Markt",
  "#5": "ST_8_5_Probe",
  "# 5": "ST_8_5_Probe",
  "#6": "ST_9_6_Zertifikat",
  "# 6": "ST_9_6_Zertifikat",
  "http://bit.ly/33333315": "ST_10a_7_Moulin",
  "bit.ly/33333315": "ST_10a_7_Moulin",
  33333315: "ST_10a_7_Moulin",
  "Yum Cha": "ST_6_3_Yumcha",
  Yumcha: "ST_6_3_YumCha",
  "Fall #2": "*SD_5_2_Restaurant",
  Fall2: "*SD_5_2_Restaurant",
  "Fall 2": "*SD_5_2_Restaurant",
  "Fall#2": "*SD_5_2_Restaurant",
  "Caso#2": "*SD_5_2_Restaurant",
  "Caso #2": "*SD_5_2_Restaurant",
  CAso2: "*SD_5_2_Restaurant",
  "Caso 2": "*SD_5_2_Restaurant",
  "Cas 2": "*SD_5_2_Restaurant",
  Cas2: "*SD_5_2_Restaurant",
  "Cas#2": "*SD_5_2_Restaurant",
  "cas #2": "*SD_5_2_Restaurant",
  Fall1: "*SD_40_1_Fingerprint",
  "FALL 1": "*SD_40_1_Fingerprint",
  "Fall #1": "*SD_40_1_Fingerprint",
  "Fall#1": "*SD_40_1_Fingerprint",
  Fall3: "*SD_6a_3_Galerie",
  "Fall#3": "*SD_6a_3_Galerie",
  "Fall 3": "*SD_6a_3_Galerie",
  "caso 3": "*SD_6a_3_Galerie",
  Caso3: "*SD_6a_3_Galerie",
  "Caso #3": "*SD_6a_3_Galerie",
  "Caso#3": "*SD_6a_3_Galerie",
  Cas3: "*SD_6a_3_Galerie",
  "Cas 3": "*SD_6a_3_Galerie",
  "Cas #3": "*SD_6a_3_Galerie",
  "Cas#3": "*SD_6a_3_Galerie",
  Fall4: "*SD_7_4_Gruppe",
  "Fall 4": "*SD_7_4_Gruppe",
  "Fall #4": "*SD_7_4_Gruppe",
  "Fall#4": "*SD_7_4_Gruppe",
  "Caso#4": "*SD_7_4_Gruppe",
  "Caso #4": "*SD_7_4_Gruppe",
  Caso4: "*SD_7_4_Gruppe",
  "Caso 4": "*SD_7_4_Gruppe",
  Cas4: "*SD_7_4_Gruppe",
  "Cas 4": "*SD_7_4_Gruppe",
  "Cas #4": "*SD_7_4_Gruppe",
  "Cas#4": "*SD_7_4_Gruppe",
  174: "ST_10_7_Moulin",
  aufleosung: "ST_10_7_Moulin",
  Auflösung: "ST_10_7_Moulin",
  "1 7 4": "ST_10_7_Moulin",
}